import React from 'react'

export const Accessories = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 15' fill={color}>
        <path
          data-name='Path 53'
          d='M17.356 0H.643A.643.643 0 000 .643v10.925a.643.643 0 00.643.643h16.714a.643.643 0 00.643-.643V.643A.644.644 0 0017.356 0zM2.431 11.27a1.306 1.306 0 111.306-1.306 1.306 1.306 0 01-1.306 1.306zm0-3.857a1.305 1.305 0 11.924-.382 1.306 1.306 0 01-.924.382zm0-3.857a1.306 1.306 0 11.925-.384 1.306 1.306 0 01-.925.384zm3.218 7.714a1.307 1.307 0 11.922-.382 1.306 1.306 0 01-.922.382zm0-3.857a1.307 1.307 0 11.922-.381 1.306 1.306 0 01-.922.381zm0-3.857a1.307 1.307 0 11.92-.385 1.306 1.306 0 01-.92.385zm3.218 7.714a1.09 1.09 0 10-.008 0zm0-3.857a1.091 1.091 0 10-.008 0zm0-3.857a1.091 1.091 0 10-.008 0zm3.218 7.714a1.1 1.1 0 10-.012 0zm-1.306-5.166a.525.525 0 11-.012 0zm1.306-2.551a1.571 1.571 0 10-.012 0zm4.8 7c0 .355-.412.643-.921.643H15.5c-.508 0-.921-.288-.921-.643V1.768c0-.355.412-.643.921-.643h.461c.508 0 .921.288.921.643z'
        />
        <path
          data-name='Path 54'
          d='M16.348 2.78c-.318-1.052-.434-.893-.476-1.186-.013-.1-.346-.095-.351 0-.017.261-.15.378-.365.888-.236.562-.193 1 0 1.186h-.069v2.52a.274.274 0 00-.085.2v4.2h1.445v-4.2a.273.273 0 00-.085-.2V3.684c.106-.13.143-.393-.014-.904zm-.29 3.134h-.672V3.971h.67z'
        />
        <path data-name='Path 55' d='M2.43 1.246a1 1 0 101 1 1 1 0 00-1-1z' />
        <path data-name='Path 56' d='M12.073 1.246a1 1 0 101 1 1 1 0 00-1-1z' />
        <path data-name='Path 57' d='M8.859 5.103a1 1 0 101 1 1 1 0 00-1-1z' />
        <path data-name='Path 58' d='M5.645 8.96a1 1 0 101 1 1 1 0 00-1-1z' />
        <path data-name='Path 59' d='M12.073 8.96a1 1 0 101 1 1 1 0 00-1-1z' />
      </g>
    </svg>
  )
}

export const BathOil = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 27' fill={color}>
        <path
          data-name='Path 67'
          d='M3.866 16.077a2.481 2.481 0 001.645-1.613h-.42q-.269 0-.531-.012a1.23 1.23 0 01-.87.755.724.724 0 10.175.863z'
        />
        <path
          data-name='Path 68'
          d='M15.172 16.479a.725.725 0 10-.432-1.309 1.458 1.458 0 01-.78-.77 4.085 4.085 0 01-.686.062h-.315a2.318 2.318 0 001.543 1.579.725.725 0 00.67.438z'
        />
        <path
          data-name='Path 69'
          d='M13.988 2.638l-1.482-1.482a5.015 5.015 0 00-1.356.863l1.972 1.972a4.972 4.972 0 00.866-1.353z'
        />
        <path
          data-name='Path 70'
          d='M11.173 3.19a.148.148 0 00.108-.043l.208-.208a.147.147 0 00-.164-.237.15.15 0 00-.044.029l-.209.208a.148.148 0 00.108.252z'
        />
        <path
          data-name='Path 71'
          d='M10.547 3.819a.148.148 0 00.108-.043l.208-.208a.148.148 0 00-.208-.208l-.208.208a.148.148 0 00.108.251z'
        />
        <path
          data-name='Path 72'
          d='M9.92 4.445a.148.148 0 00.108-.043l.208-.208a.148.148 0 00-.208-.208l-.208.208a.148.148 0 00.108.251z'
        />
        <path
          data-name='Path 73'
          d='M11.932 3.313a.146.146 0 00-.193-.193.15.15 0 00-.044.029l-.208.209a.148.148 0 00.209.208l.208-.209a.144.144 0 00.028-.044z'
        />
        <path
          data-name='Path 74'
          d='M11.277 3.775a.148.148 0 00-.208 0l-.208.208a.148.148 0 00.209.208l.208-.208a.148.148 0 000-.208z'
        />
        <path
          data-name='Path 75'
          d='M10.652 4.402a.148.148 0 00-.208 0l-.208.209a.148.148 0 00.209.208l.208-.209a.148.148 0 000-.208z'
        />
        <path
          data-name='Path 76'
          d='M12.007 4.028a.148.148 0 00.108-.043l.208-.208a.143.143 0 00.029-.044.148.148 0 00-.238-.164l-.208.208a.148.148 0 000 .208.146.146 0 00.101.043z'
        />
        <path
          data-name='Path 77'
          d='M11.38 4.654a.148.148 0 00.108-.043l.208-.208a.148.148 0 00-.208-.208l-.208.208a.148.148 0 00.108.251z'
        />
        <path
          data-name='Path 78'
          d='M10.756 5.28a.148.148 0 00.108-.043l.208-.208a.148.148 0 00-.208-.208l-.208.208a.148.148 0 00.108.251z'
        />
        <path
          data-name='Path 79'
          d='M17.414 7.083h-.886V.295a.295.295 0 00-.3-.3h-1.277a.3.3 0 00-.2.078l-1.061.976a1.175 1.175 0 00-.69.096l1.013 1.014a1.187 1.187 0 00.083-.68l.966-.888h.872v6.493H.59a.59.59 0 00-.59.591v.59a.59.59 0 00.59.59h.367c.045.229.108.491.176.794l.413 1.98a2.9 2.9 0 003.138 2.53c.134 0 .27.006.408.006h8.191a3.876 3.876 0 00.565-.041 3.157 3.157 0 002.637-2.342l.671-2.929h.3A.588.588 0 0018 8.265v-.59a.59.59 0 00-.586-.592zm-4.7 6.168a.035.035 0 000 .005v-.005z'
        />
      </g>
    </svg>
  )
}

export const BeautyHealth = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 12'>
        <g data-name='Group 11' fill={color}>
          <path
            data-name='Path 31'
            d='M2.662 15.865a.612.612 0 00.611.611H4.82a.612.612 0 00.611-.611v-1.368H2.662z'
          />
          <path
            data-name='Path 32'
            d='M1.435 13.195a.793.793 0 00.791.791h3.64a.793.793 0 00.791-.791l1.015-8.766-6.614 5.507z'
          />
          <path
            data-name='Path 33'
            d='M7.3 0H.791A.791.791 0 000 .79l.917 7.919 6.927-5.768L8.093.79a.791.791 0 00-.792-.791z'
          />
          <path
            data-name='Path 34'
            d='M15.238 7.065a.769.769 0 00-.769-.769h-1.9a.769.769 0 00-.769.769v1.742h3.443z'
          />
          <path
            data-name='Path 35'
            d='M16.269 9.343a2.021 2.021 0 00-.275-.02h-4.956a2.006 2.006 0 00-2 2v3.661a2 2 0 002 2h4.956a2 2 0 002.005-2v-3.66a2 2 0 00-1.731-1.985zm-2.753 5.4a1.582 1.582 0 111.582-1.582 1.582 1.582 0 01-1.582 1.582z'
          />
        </g>
      </g>
    </svg>
  )
}

export const Beverage = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 9'>
        <path
          data-name='Path 30'
          d='M12.405.7a3.635 3.635 0 00-3.591 3.1H4.4L.811 0 .043.723l2.9 3.084H-.001l6.262 7.018v6.121H3.327V18h7.03v-1.054H7.32v-6.122l3.091-3.46a3.629 3.629 0 102-6.66zM9.817 6.442H3.771L2.358 4.863h8.87z'
          fill={color}
        />
      </g>
    </svg>
  )
}

export const Breakfast = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 7' fill={color}>
        <path
          data-name='Path 27'
          d='M13.034 14.465c2.98-.12 4.31-1.476 4.31-3.136 0-1.442-1-2.655-3.217-3.028.01-.539.011-1.054.011-1.536H0c0 3.158 0 7.743 2.84 9.935-1.724.131-2.84.342-2.84.577 0 .4 3.163.723 7.067.723s7.066-.323 7.066-.723c0-.236-1.118-.446-2.84-.577a5.965 5.965 0 001.741-2.235zm1.035-4.79c1.243.288 1.465.9 1.451 1.687-.016.9-.276 1.508-1.973 1.712a16.339 16.339 0 00.521-3.4zM1.706 7.862h2.209c-.99 2.922.681 7.542.68 7.542-3.611-2.765-2.889-7.542-2.889-7.542z'
        />
        <path
          data-name='Path 28'
          d='M8.229 4.861c.281-2.545 5.9-1.272 4.729-4.576-.18-.5-.989-.287-.808.222.514 1.449-1.437 1.625-2.432 1.958a2.92 2.92 0 00-2.328 2.4c-.061.534.774.528.839-.004z'
        />
        <path
          data-name='Path 29'
          d='M12.207 3.082a2.924 2.924 0 00-2.439 1.879.419.419 0 00.807.222c.377-1.272 2.047-1.293 3.115-1.6a2.031 2.031 0 001.644-2.346c-.069-.528-.906-.539-.837 0 .195 1.472-1.16 1.579-2.29 1.845z'
        />
      </g>
    </svg>
  )
}

export const Cooking = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g fill={color}>
        <path
          data-name='Path 22'
          d='M13.68 6.482H9.835a.63.63 0 100-1.259H8.268a.63.63 0 000 1.259H4.417a2.327 2.327 0 00-2.127 1.98h13.52a2.328 2.328 0 00-2.13-1.98z'
        />
        <path
          data-name='Path 23'
          d='M15.84 9.544v-.18H0v.9h2.256v5.578a2.16 2.16 0 002.16 2.16h9.264a2.16 2.16 0 002.16-2.16v-5.398H18v-.9z'
        />
        <path
          data-name='Path 24'
          d='M5.743 2.166a3.089 3.089 0 00.2.237l.175.175c.112.112.213.224.294.321a1.464 1.464 0 01.1.137.266.266 0 01.051.112.269.269 0 01-.068.178 1.08 1.08 0 01-.2.188.636.636 0 00.309.036.544.544 0 00.336-.167.655.655 0 00.165-.4 1.1 1.1 0 00-.043-.375 1.972 1.972 0 00-.279-.572 3.125 3.125 0 00-.173-.224 1.837 1.837 0 01-.135-.176 1.679 1.679 0 01-.336-.69 1.736 1.736 0 01.157-.945 1.162 1.162 0 00-.858.873 1.4 1.4 0 00.017.7 1.888 1.888 0 00.289.6z'
        />
        <path
          data-name='Path 25'
          d='M8.077 2.166c.063.083.13.162.2.237l.173.175c.112.112.213.224.3.321.039.05.073.1.1.137a.243.243 0 01.05.112.264.264 0 01-.067.178 1.041 1.041 0 01-.2.188.642.642 0 00.31.036.543.543 0 00.336-.167.653.653 0 00.165-.4 1.1 1.1 0 00-.041-.375 2 2 0 00-.28-.572c-.055-.082-.124-.165-.173-.224a1.837 1.837 0 01-.135-.176 1.679 1.679 0 01-.336-.694A1.736 1.736 0 018.63 0a1.161 1.161 0 00-.857.873 1.4 1.4 0 00.016.7 1.884 1.884 0 00.289.6z'
        />
        <path
          data-name='Path 26'
          d='M10.204 2.166a2.971 2.971 0 00.2.237l.175.175c.112.112.212.224.294.321a1.465 1.465 0 01.1.137.28.28 0 01.051.112.266.266 0 01-.068.178 1.041 1.041 0 01-.2.188.64.64 0 00.309.036.547.547 0 00.336-.167.654.654 0 00.163-.4 1.086 1.086 0 00-.041-.375 1.96 1.96 0 00-.279-.572 3.125 3.125 0 00-.173-.224 1.672 1.672 0 01-.135-.176 1.679 1.679 0 01-.33-.694 1.738 1.738 0 01.151-.941A1.16 1.16 0 009.9.874a1.4 1.4 0 00.017.7 1.857 1.857 0 00.29.6z'
        />
      </g>
    </svg>
  )
}

export const Dairy = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g fill={color}>
        <path
          data-name='Path 19'
          d='M4.313 14.945V12.23a.34.34 0 00-.34-.34H.332a5.534 5.534 0 00-.125 3.393h3.767a.34.34 0 00.339-.338z'
        />
        <path
          data-name='Path 20'
          d='M7.652 16.402l.345-.4a3.843 3.843 0 00-.065-4.593l-.223-.278V9.176a1.876 1.876 0 01-.21-.465 1.015 1.015 0 00-.462-1.925H2.968a1.018 1.018 0 00-.391 1.958A2.656 2.656 0 011.7 9.93a4.641 4.641 0 00-1.056 1.282h3.331a1.019 1.019 0 011.014 1.017v2.714a1.019 1.019 0 01-1.018 1.018H.462A3.259 3.259 0 003.41 18h3.261a3.056 3.056 0 001.428-.36 2.313 2.313 0 01-.321-.723zM3.689 8.147h-.722a.34.34 0 010-.678h4.07a.34.34 0 110 .678H3.682z'
        />
        <path data-name='Rectangle 1' d='M13.136 7.14h3.732v7.465h-3.732z' />
        <path
          data-name='Path 21'
          d='M15.237 3.144l-.25-.21a.4.4 0 01-.13-.321.547.547 0 01.062-.221h-2.368a.34.34 0 010-.678h2.886a1.006 1.006 0 00.071-.353v-.343A1.019 1.019 0 0014.492 0H10.76a1.019 1.019 0 00-1.018 1.018v.34a1 1 0 00.072.353h1.38a.34.34 0 010 .678h-.838a.546.546 0 01.073.2.355.355 0 01-.081.284.68.68 0 01-.063.063c-.077.066-.158.133-.241.2a3.638 3.638 0 00-1.657 2.967v4.786l.074.092a4.507 4.507 0 01.049 5.461l-.115.133.042.171a1.619 1.619 0 001.572 1.233h5.24a1.623 1.623 0 001.622-1.622v-1.074h-4.414V6.462h4.411v-.355a3.645 3.645 0 00-1.631-2.963z'
        />
      </g>
    </svg>
  )
}

export const Deodorent = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='018---Roll-On' fill={color}>
        <ellipse
          cx='1.607'
          cy='3.535'
          rx='1.607'
          ry='3.535'
          transform='translate(2.176 8.678)'
        />
        <path d='M7.244 4.821H.321a.321.321 0 00-.32.356l.027.254a71.835 71.835 0 01.311 11.215A1.282 1.282 0 001.621 18h4.325a1.282 1.282 0 001.282-1.353 71.835 71.835 0 01.3-11.214l.027-.254a.321.321 0 00-.316-.358zm-6.355.962a.321.321 0 01.321-.321h.641a.321.321 0 110 .641H1.21a.321.321 0 01-.321-.32zm2.9 10.607c-1.261 0-2.25-1.832-2.25-4.178s.988-4.178 2.25-4.178 2.25 1.832 2.25 4.178-.995 4.181-2.256 4.181zM6.354 6.104H3.14a.321.321 0 110-.641h3.214a.321.321 0 110 .641z' />
        <path
          data-name='Shape'
          d='M3.783 0a2.25 2.25 0 00-2.224 1.929h4.447A2.25 2.25 0 003.783 0zM6.443 2.572H1.128a5.946 5.946 0 00-.237 1.607h5.785a5.946 5.946 0 00-.233-1.607zM11.82 16.716h3.214v-1.284a2.893 2.893 0 10-5.786 0v1.284h.964a.321.321 0 010 .641h-.964v.321a.321.321 0 00.321.321h5.143a.321.321 0 00.321-.321v-.321H11.82a.321.321 0 110-.641zm-.964-1.929a.321.321 0 01-.641 0 1.55 1.55 0 011.606-1.608.321.321 0 110 .641.916.916 0 00-.966.964z'
        />
      </g>
    </svg>
  )
}

export const Eyes = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g fill={color}>
        <path
          data-name='Path 49'
          d='M3.002 0h-1.5v.75h-1.5v1.5h1.5V3h-1.5v1.5h1.5v.75h-1.5v1.5h1.5v3.75h-.75a.75.75 0 00-.744.842l.75 6a.75.75 0 00.744.657h1.5a.75.75 0 00.744-.657l.75-6a.75.75 0 00-.744-.842h-.75V6.748h1.5v-1.5h-1.5V4.5h1.5V3h-1.5v-.75h1.5V.75h-1.5z'
        />
        <path
          data-name='Path 50'
          d='M11.995 17.187l-.746-9.69h-4.5l-.747 9.69a.75.75 0 00.748.807h4.5a.75.75 0 00.748-.807z'
        />
        <path
          data-name='Path 51'
          d='M11.251 5.249a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75v1.5h4.5z'
        />
      </g>
    </svg>
  )
}

export const Face = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g fill={color}>
        <path
          data-name='Path 41'
          d='M6.388 9.238c-3.319 0-5.11 1.36-5.11 1.911s1.791 1.911 5.11 1.911a9.995 9.995 0 002.653-.345 5.1 5.1 0 011.387-2.612 8.865 8.865 0 00-4.04-.864z'
        />
        <path
          data-name='Path 42'
          d='M8.34 8.908a7.515 7.515 0 012.3.841 5.111 5.111 0 01.581-.391 7 7 0 00-1.969-.887 5.957 5.957 0 01-.912.438z'
        />
        <path
          data-name='Path 43'
          d='M8.958 13.383a10.774 10.774 0 01-2.571.3c-3.29 0-5.749-1.349-5.749-2.555 0-.908 1.394-1.9 3.484-2.33a6.017 6.017 0 01-.9-.433c-1.96.571-3.224 1.647-3.224 2.762 0 1.731 2.922 3.193 6.388 3.193a11.64 11.64 0 002.573-.285c-.008-.112-.018-.234-.018-.354.002-.097.011-.197.017-.298z'
        />
        <path
          data-name='Path 44'
          d='M6.388 8.952a4.833 4.833 0 005.11-4.471A4.833 4.833 0 006.388.01a4.833 4.833 0 00-5.11 4.471 4.833 4.833 0 005.11 4.471zm0-8.3a4.194 4.194 0 014.471 3.833 4.194 4.194 0 01-4.471 3.833A4.194 4.194 0 011.917 4.48 4.194 4.194 0 016.388.647z'
        />
        <path
          data-name='Path 45'
          d='M6.391 7.675a3.561 3.561 0 003.833-3.193 3.561 3.561 0 00-3.833-3.195A3.561 3.561 0 002.558 4.48a3.561 3.561 0 003.833 3.195zm0-5.749a2.969 2.969 0 013.193 2.555h-.638c0-1.039-1.17-1.911-2.555-1.911z'
        />
        <path
          data-name='Path 46'
          d='M17.39 11.304a6.91 6.91 0 01-.592.319 5.4 5.4 0 00-2.518 2.518 6.026 6.026 0 01-2.81 2.81 7.22 7.22 0 00-.486.259 4.466 4.466 0 006.407-5.9zm-3.877 6.051v-.638a3.238 3.238 0 00.581-.053l.112.628a3.847 3.847 0 01-.694.063zm1.394-.261l-.233-.595a3.176 3.176 0 002.032-2.976h.638a3.812 3.812 0 01-2.438 3.571z'
        />
        <path
          data-name='Path 47'
          d='M12.66 15.332a4.74 4.74 0 001.044-1.472 6.029 6.029 0 012.809-2.815c.173-.085.337-.17.518-.278a4.527 4.527 0 00-.4-.45 6.37 6.37 0 01-.731.407 5.386 5.386 0 00-2.512 2.521 6.03 6.03 0 01-2.81 2.81 6.962 6.962 0 00-.532.285 4.507 4.507 0 00.414.438 6.34 6.34 0 01.727-.406 4.733 4.733 0 001.474-1.042z'
        />
        <path
          data-name='Path 48'
          d='M11.769 14.439a4.74 4.74 0 001.044-1.472 6.022 6.022 0 012.81-2.81c.166-.082.328-.164.5-.265a4.462 4.462 0 00-6.435 5.922c.219-.136.419-.236.614-.337a4.747 4.747 0 001.47-1.037z'
        />
      </g>
    </svg>
  )
}

export const FacialCare = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <path
        d='M14.651 1.933a3.534 3.534 0 00-3.5 6.1h.1a1.285 1.285 0 011.033.527 3.549 3.549 0 002.37-.206 3.213 3.213 0 110-6.425z'
        fill={color}
      />
      <path
        data-name='Shape'
        d='M12.86 0a5.147 5.147 0 00-4.247 8.037h1.555a4.176 4.176 0 014.755-6.693.643.643 0 01-.244 1.226 2.57 2.57 0 000 5.14.643.643 0 01.248 1.23 4.207 4.207 0 01-2.261.349c-.173-.021-.125-.045-.125.032v.958A5.143 5.143 0 0012.862 0zM1.284 16.715h4.5a.322.322 0 110 .643H1.915a2.362 2.362 0 001.606.643h6.457a2.19 2.19 0 001.113-.292 5.568 5.568 0 002.365-4.533H.046a6.639 6.639 0 001.238 3.534zm5.792 0a.321.321 0 11-.321.321.321.321 0 01.321-.321zM12.77 11.253H.731a.743.743 0 00-.731.75c0 .176 0 .3.007.535h13.486c.007-.244.007-.373.007-.535a.743.743 0 00-.73-.75z'
        fill={color}
      />
      <path
        data-name='Shape'
        d='M1.607 9.322v1.285h10.288V9.322a.643.643 0 00-.642-.642h-9a.643.643 0 00-.646.642z'
        fill={color}
      />
    </svg>
  )
}

export const FruitsVegetable = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Layer 2'>
        <g data-name='Layer 3'>
          <path
            data-name='Path 16'
            d='M10.235 3.966a2.943 2.943 0 00-1.38-2.122c-.528-.243-.485-.618-.338-.854s.41-.231.832.164a5 5 0 011.368 2.87z'
            fill={color}
            stroke={color}
            strokeMiterlimit='10'
            strokeWidth='.416'
          />
          <path
            data-name='Path 17'
            d='M6.514 7.976a4.757 4.757 0 109.513 0c0-2.627-1.5-4.976-4.757-4.73-2.619.197-4.767 1.656-4.756 4.73z'
            fill='none'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.387'
          />
          <path
            data-name='Path 18'
            d='M6.514 7.976a4.757 4.757 0 109.513 0c0-2.627-1.5-4.976-4.757-4.73-2.619.197-4.767 1.656-4.756 4.73z'
            fill={color}
          />
          <path
            data-name='Path 19'
            d='M14.731 5.045s1.506 1.544.714 2.993c-.287.526-1.2.192-1.234-.485s.25-1.27-.236-2.05c-.349-.566.26-.878.756-.458z'
            fill='#fff'
          />
          <path
            data-name='Path 20'
            d='M10.834 3.413s1.161-4.315 6.469-2.048c0 0-2.459 4.074-6.469 2.048z'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.387'
          />
          <path
            data-name='Path 21'
            d='M10.834 3.413s1.161-4.315 6.469-2.048c0 0-2.459 4.074-6.469 2.048z'
            fill='#fff'
          />
          <path
            data-name='Path 22'
            d='M10.516 4.513a10.193 10.193 0 015.63-2.863c-2.736-.521-6.018 1.748-6.018 1.748s.289.864.388 1.115z'
            fill={color}
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='.035'
          />
          <path
            data-name='Path 23'
            d='M10.895 9.896h0c-.268-.877-1.969-1.65-4.234-1.72a5.286 5.286 0 00-4.515 1.858 2 2 0 00-.551 1.308h0a4.934 4.934 0 004.768 4.426c3.133.223 3.786-.96 4.225-1.9a6.363 6.363 0 00.307-3.972z'
            fill='#fff'
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='3.19'
          />
          <path
            data-name='Path 24'
            d='M10.895 9.896h0c-.268-.877-1.969-1.65-4.234-1.72a5.286 5.286 0 00-4.515 1.858 2 2 0 00-.551 1.308h0a4.934 4.934 0 004.768 4.426c3.133.223 3.786-.96 4.225-1.9a6.363 6.363 0 00.307-3.972z'
            fill='none'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.387'
          />
          <path
            data-name='Path 25'
            d='M10.895 9.896h0c-.268-.877-1.969-1.65-4.234-1.72a5.286 5.286 0 00-4.515 1.858 2 2 0 00-.551 1.308h0a4.934 4.934 0 004.768 4.426c3.133.223 3.786-.96 4.225-1.9a6.363 6.363 0 00.307-3.972z'
            fill='#fff'
            stroke={color}
            strokeMiterlimit='10'
            strokeWidth='.069'
          />
          <path
            data-name='Path 26'
            d='M10.895 9.896c-.268-.877-1.969-1.65-4.234-1.72a5.286 5.286 0 00-4.515 1.858 2 2 0 00-.551 1.308 4.934 4.934 0 004.768 4.426c3.133.223 3.786-.96 4.225-1.9a6.363 6.363 0 00.307-3.972z'
            fill={color}
          />
          <path
            data-name='Path 27'
            d='M1.595 11.342a4.375 4.375 0 00.128.684 2.664 2.664 0 00.3.335c1.067 1.028 4.409 1.723 7.173 1 .883-.23 1.522-1.3.526-1.851-.139-.076-.243-.184-.208-.277s.089-.106.269-.1a1.2 1.2 0 001.232-.735 4.126 4.126 0 00-.121-.509c-.272-.876-1.974-1.644-4.239-1.715a5.286 5.286 0 00-4.515 1.858 2.024 2.024 0 00-.545 1.31z'
            fill='#fff'
          />
          <path
            data-name='Path 28'
            d='M1.921 9.984a1.569 1.569 0 00.1 2.377c1.066 1.028 4.409 1.723 7.173 1 .883-.23 1.522-1.3.526-1.851-.139-.076-.243-.184-.208-.277s.089-.106.269-.1a1.183 1.183 0 001.259-.823 1.321 1.321 0 00-.785-1.413'
            fill='none'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='.416'
          />
          <path
            data-name='Path 29'
            d='M8.013 10.78c-.018.471-.87.791-1.9.752s-1.856-.423-1.837-.9.87-.963 1.9-.924 1.855.605 1.837 1.072z'
            fill={color}
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='.555'
          />
          <path
            data-name='Path 30'
            d='M9.722 12.123a2.411 2.411 0 01.467 2.08 2.759 2.759 0 01-1.5 2.427'
            fill='none'
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='.555'
          />
        </g>
      </g>
    </svg>
  )
}

export const HandBags = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 11'>
        <g
          data-name='Group 10'
          fill={color}
          stroke='#fff'
          strokeMiterlimit='10'
          strokeWidth='.091'
        >
          <path
            data-name='Path 45'
            d='M17.954 7.253v8.585a1.791 1.791 0 01-1.791 1.791H1.836a1.791 1.791 0 01-1.791-1.791V7.253c0-.988 17.909-.988 17.909 0z'
          />
          <path data-name='Rectangle 36' d='M.102 8.77h17.795v.913H.102z' />
          <path
            data-name='Path 46'
            d='M4.793 7.253C4.976 4.061 7.113.614 9 .614c2.41 0 4.049 3.84 4.207 6.639h.572C13.618 4.168 11.791.044 8.999.044c-1.131 0-2.338.922-3.312 2.529a10.463 10.463 0 00-1.466 4.68z'
          />
        </g>
      </g>
    </svg>
  )
}

export const HomeCleaning = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g transform='translate(-1.125 -1.125)' fill={color}>
        <path data-name='Path 7' d='M1.125 18.54H1.7v.58h-.58z' />
        <path data-name='Path 8' d='M18.54 18.54h.58v.58h-.58z' />
        <circle
          data-name='Ellipse 1'
          cx='.489'
          cy='.489'
          r='.489'
          transform='translate(14.28 9.345)'
        />
        <path
          data-name='Path 9'
          d='M9.834 10.968V9.543H8.409a1.744 1.744 0 001.425 1.425z'
        />
        <circle
          data-name='Ellipse 2'
          cx='.489'
          cy='.489'
          r='.489'
          transform='translate(4.99 12.247)'
        />
        <path
          data-name='Path 10'
          d='M9.834 7.537a1.744 1.744 0 00-1.425 1.425h1.425z'
        />
        <path data-name='Path 11' d='M2.867 15.64h3.486v.58H2.867z' />
        <path data-name='Path 12' d='M13.898 15.64h3.491v.58h-3.491z' />
        <path
          data-name='Path 13'
          d='M16.802 16.801H14.48v1.742h-.58v-1.742h-.58v-1.742h3.486v-6.66l-6.68-2.637-6.678 2.637v6.66h3.486v1.742h-.583v1.742h-.578v-1.742H3.448v1.742H2.286v.58h15.677v-.58h-1.161zm-3.486-7.257a1.163 1.163 0 001.164-1.165h.58a1.163 1.163 0 001.162 1.162v.58a1.163 1.163 0 00-1.159 1.162h-.58a1.163 1.163 0 00-1.162-1.162zm-3.191-2.613a2.322 2.322 0 11-2.328 2.322 2.322 2.322 0 012.328-2.322zm-4.352 7.258h-.584a1.163 1.163 0 00-1.162-1.162v-.58a1.163 1.163 0 001.162-1.162h.584a1.163 1.163 0 001.158 1.162v.58a1.163 1.163 0 00-1.158 1.162zm6.39 4.354v-3.77a2.032 2.032 0 10-4.064 0v3.77h-.584v-3.77a2.613 2.613 0 115.225 0v3.77zm-3.49-2.322v-.58h.59v.58z'
        />
        <path
          data-name='Path 14'
          d='M11.839 9.543h-1.425v1.425a1.744 1.744 0 001.425-1.425z'
        />
        <path
          data-name='Path 15'
          d='M18.049 6.598l-7.925-3.13-7.925 3.13a.772.772 0 00-.494.722.76.76 0 00.337.637.787.787 0 00.742.082l7.337-2.9 7.337 2.9a.787.787 0 00.742-.082.76.76 0 00.337-.637.772.772 0 00-.494-.719z'
        />
        <path
          data-name='Path 16'
          d='M10.414 7.537v1.425h1.425a1.744 1.744 0 00-1.425-1.425z'
        />
        <path
          data-name='Path 17'
          d='M17.962 2.286h-.58a1.163 1.163 0 01-1.162 1.162v.58a1.163 1.163 0 011.162 1.162h.58a1.163 1.163 0 011.162-1.162v-.58a1.163 1.163 0 01-1.162-1.162z'
        />
        <path
          data-name='Path 18'
          d='M4.028 4.027h.58a1.163 1.163 0 011.161-1.161v-.58a1.163 1.163 0 01-1.16-1.161h-.58a1.163 1.163 0 01-1.162 1.161v.58a1.163 1.163 0 011.161 1.161z'
        />
      </g>
    </svg>
  )
}

export const LaptopBags = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g
        data-name='Group 6'
        fill={color}
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='.091'
      >
        <path
          data-name='Path 22'
          d='M6.224 1.741a.408.408 0 01-.292-.175l-.013-.018v-.022c-.08-.612.818-.747.856-.753l.4-.057-.334.222h0a.807.807 0 00-.128.338c-.105.42-.375.465-.489.465zm-.13-.263a.213.213 0 00.13.081c.106 0 .244-.056.305-.323a1.686 1.686 0 01.07-.237c-.214.064-.523.205-.505.479z'
        />
        <path
          data-name='Path 23'
          d='M9 6.496H.046v6.8a.833.833 0 00.833.833h16.243a.833.833 0 00.833-.833v-6.8z'
        />
        <path
          data-name='Path 24'
          d='M17.44 2.135H.561a.515.515 0 00-.515.515v6.285a.833.833 0 00.833.833h16.243a.833.833 0 00.833-.833V2.65a.515.515 0 00-.515-.515z'
        />
        <path
          data-name='Path 25'
          d='M11.776 1.741c-.113 0-.387-.045-.482-.464a.734.734 0 00-.134-.342l-.334-.222.4.061c.038.006.936.141.856.753v.022l-.013.018a.408.408 0 01-.293.174zM11.4.999a1.682 1.682 0 01.071.238c.061.267.2.323.305.323a.216.216 0 00.13-.081c.019-.276-.291-.416-.506-.48z'
        />
        <path
          data-name='Path 26'
          d='M11.295.752A3.333 3.333 0 009 .045a3.333 3.333 0 00-2.295.707.136.136 0 00.158.222A3.036 3.036 0 018.999.318a3.037 3.037 0 012.136.656.136.136 0 10.158-.222z'
        />
        <path data-name='Path 27' d='M9 9.419h-.958v.751h1.917v-.751z' />
        <path
          data-name='Path 28'
          d='M8.698 8.214h0a.9.9 0 00-.657 1.24h1.917a.9.9 0 00-.657-1.24h0a1.656 1.656 0 00-.6 0z'
        />
        <path data-name='Path 29' d='M9 10.17h-.958v1.009h1.917V10.17z' />
        <path data-name='Path 30' d='M9 10.473h-.807v.706h1.615v-.706z' />
        <path
          data-name='Path 31'
          d='M4.725 2.135h1.136a1.287 1.287 0 00.648-.83.118.118 0 00-.117-.139h0a.116.116 0 00-.095.048 1.873 1.873 0 01-1.38.721.118.118 0 00-.088.05z'
        />
        <path
          data-name='Path 32'
          d='M13.275 2.135H12.14a1.287 1.287 0 01-.648-.83.118.118 0 01.116-.139h0a.116.116 0 01.095.048 1.873 1.873 0 001.38.721.118.118 0 01.088.05z'
        />
      </g>
    </svg>
  )
}

export const Lips = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 14'>
        <path
          data-name='Path 52'
          d='M6.035 17.392v-6.2a.567.567 0 00-.516-.61H5.5V5.269h-.527c0-.877.008-1.608.013-2.212.019-2.149.023-2.66-.235-2.923A.454.454 0 004.422 0a1.282 1.282 0 00-.549.193 4.29 4.29 0 01-.708.3 2.882 2.882 0 00-2.117 2.235v2.541H.541v5.306H.519a.567.567 0 00-.516.61v6.2a.567.567 0 00.516.61h5.006a.567.567 0 00.51-.603zm-1.144-6.817H1.148V5.932l3.743.043z'
          fill={color}
        />
      </g>
    </svg>
  )
}

export const MeatFish = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Layer 2'>
        <g data-name='Layer 1'>
          <path
            data-name='Path 31'
            d='M9.976 12.775c-3.038-.539-8.7-1.222-9.868-4.621h.008C-.977 5.471 5.959-1.484 8.663.284a2.2 2.2 0 011.139 1.685c.058 1.832-1.961 4.468-4.123 6.1 2.183-1.393 4.262-4.117 4.643-6.1a9.461 9.461 0 011.014 9.288c1.112 1.079 2.5 2.252 3.735 2.053a1.566 1.566 0 011.868 1.437 1.49 1.49 0 01-.662 1.445 1.394 1.394 0 01-.877.2 1.34 1.34 0 01-.143.82 1.621 1.621 0 01-3-1c.117-1.248-1.117-2.45-2.279-3.435zM6.212 2.807c.983.643-2.222 3.936-3.21 3.293s2.226-3.936 3.21-3.293zM8.302.936c2.58 1.689-4.417 9.1-7 7.415s4.417-9.1 7-7.415zm3.072 11.145l-1.6-.155c1.211 1.034 3.237 2.4 3.062 4.271-.161 1.724 2.284 1.5 1.988.126a.4.4 0 01.475-.5c1.417.243 1.47-2.216-.184-1.949-1.318.21-2.647-.774-3.747-1.793z'
            fill={color}
            fillRule='evenodd'
          />
        </g>
      </g>
    </svg>
  )
}

export const OralCare = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g fill={color}>
        <path
          data-name='Path 65'
          d='M3.118 11.024a2.267 2.267 0 01.142 1.454l-.027.333c-.127 1.655.111 3.807 1.157 4.887a.463.463 0 00.1.046.252.252 0 00.317-.127.255.255 0 00.017-.15v-.02c-.017-.157-.385-3.87 1.27-5.887a1.035 1.035 0 011.6.009c1.623 2.025 1.257 5.719 1.241 5.875v.02a.255.255 0 00.017.15.252.252 0 00.317.127.388.388 0 00.111-.049c1.043-1.078 1.281-3.231 1.154-4.887a35.384 35.384 0 00-.027-.333 2.268 2.268 0 01.142-1.455 3.792 3.792 0 011.517-1.087 2.221 2.221 0 001-1.522 3.819 3.819 0 00-.16-2.192c-.555-1.388-1.827-1.924-3.5-1.466a4.521 4.521 0 00-1.368.622c-.2.126-.409.253-.666.384a2.761 2.761 0 001.566.237.248.248 0 11.1.486 3.837 3.837 0 01-2.355-.493 10.454 10.454 0 01-.478-.265 7.466 7.466 0 00-2.338-1.014A2.73 2.73 0 00.698 6.581a2.908 2.908 0 00.92 3.343 3.784 3.784 0 011.5 1.1z'
        />
        <path
          data-name='Path 66'
          d='M17.256.93H6.409L6.036.558A1.888 1.888 0 004.693.003H.664a.666.666 0 00-.666.666v1.889a.25.25 0 00.5 0V.667A.165.165 0 01.663.502h.1v2.087a.25.25 0 10.5 0V.497h.222v2.087a.25.25 0 10.5 0V.497h.222v2.087a.25.25 0 10.5 0V.497h.222v2.087a.25.25 0 10.5 0V.497h.222v2.087a.25.25 0 10.5 0V.497h.222v2.087a.25.25 0 10.5 0V.507a1.4 1.4 0 01.823.4l.792.789a1.888 1.888 0 001.343.555h9.441a.666.666 0 100-1.323z'
        />
      </g>
    </svg>
  )
}

export const OuterWear = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 29' fill={color}>
        <path
          data-name='Path 99'
          d='M15.643 5.659a1.993 1.993 0 00.453-.062c-.224-1.2-.4-1.9-.4-1.9a5.546 5.546 0 00-1.713-1.068 1.964 1.964 0 001.66 3.03z'
        />
        <path
          data-name='Path 100'
          d='M.896 5.596a1.962 1.962 0 002.113-2.97 5.561 5.561 0 00-1.712 1.068s-.178.697-.401 1.902z'
        />
        <path
          data-name='Path 101'
          d='M15.641 6.146a2.466 2.466 0 01-2.463-2.463 2.436 2.436 0 01.348-1.24 14.661 14.661 0 00-2.08-.61L11.422.664A5.484 5.484 0 008.947.008c-.225-.01-.677-.01-.904 0a5.5 5.5 0 00-2.478.653l-.02 1.169a14.746 14.746 0 00-2.08.612 2.446 2.446 0 01-2.658 3.64 53.686 53.686 0 00-.771 11.244H.26v.123a.512.512 0 00.532.493h1.24a.512.512 0 00.532-.493v-.123h.23s-.238-7.281 1.02-9.143v9.08a23.275 23.275 0 004.326.735V1.151a5.227 5.227 0 01-1.749-.19S6.529.498 8.043.516h.9c1.5.023 1.653.445 1.653.445a5.226 5.226 0 01-1.751.19v16.847a23.274 23.274 0 004.329-.736V8.184c1.259 1.866 1.023 9.143 1.023 9.143h.229v.123a.511.511 0 00.532.493H16.2a.512.512 0 00.532-.493v-.123h.224a53.827 53.827 0 00-.771-11.246 2.462 2.462 0 01-.544.065z'
        />
      </g>
    </svg>
  )
}

export const Pants = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g fill={color}>
        <path
          data-name='Path 102'
          d='M7.999 1.165a10.721 10.721 0 00-.139-.71L7.797.187A.243.243 0 007.561 0H.553a.243.243 0 00-.236.187L.253.455c-.056.235-.1.472-.139.71z'
        />
        <path
          data-name='Path 103'
          d='M.018 2.048a9.93 9.93 0 00-.015.828l.379 13.479a.243.243 0 00.242.236H.86v1.155a.254.254 0 00.254.254h1.288a.254.254 0 00.254-.254v-1.155h.172a.243.243 0 00.242-.225l.833-11.228a.15.15 0 01.3 0l.825 11.228a.243.243 0 00.242.225h.233v1.155a.254.254 0 00.254.254h1.288a.254.254 0 00.254-.254v-1.155h.179a.243.243 0 00.242-.236L8.1 2.876c.008-.276 0-.553-.015-.828z'
        />
      </g>
    </svg>
  )
}

export const PetCare = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g fill={color}>
        <path
          data-name='Path 1'
          d='M11.335 8.363h-.139a4.189 4.189 0 01-1.864-.44l-1.116-.558.011-.022-.493.493a1.283 1.283 0 01.536.457.879.879 0 00.732.392.326.326 0 01.326.326v.643a1.288 1.288 0 01-.964 1.245v.888a1.76 1.76 0 01-.3.977l-.35.515v.734l.737-.737a.326.326 0 01.548.227v2.186l.643-.426v-2.4a.326.326 0 01.128-.257l1.257-.944a2.143 2.143 0 00.5-1.274 4.447 4.447 0 00-.034-.809z'
        />
        <path
          data-name='Path 2'
          d='M9.08 7.077l.543.27a3.543 3.543 0 001.577.372h.056V5.791a.326.326 0 01.326-.326h.8a.483.483 0 00.482-.482v-.472h-.643a.326.326 0 01-.227-.094l-.651-.651a.76.76 0 00-.543-.223h-.7a.8.8 0 00-.564.233 2.932 2.932 0 00-.869 2.086v.573h.4a.242.242 0 00.241-.241V5.149h.643v1.045a.885.885 0 01-.881.887zm1.206-2.894h.643v.643h-.643z'
        />
        <path
          data-name='Path 3'
          d='M10.287 14.841l.643-.426v-1.873l-.643.482z'
        />
        <path
          data-name='Path 4'
          d='M17.794 3.684a6.04 6.04 0 00-.612-1.464 4.466 4.466 0 00-7.43-.434l-.493.651a.326.326 0 01-.515 0l-.493-.651A4.488 4.488 0 004.678 0H4.56A4.466 4.466 0 00.789 2.077 5.038 5.038 0 000 4.783v.929a7.535 7.535 0 003.244 6.206l.326-.485a8.686 8.686 0 01-1.6-1.539l-.29-.362a.326.326 0 01.5-.4l.289.362a8.042 8.042 0 001.455 1.412l.9-1.346v-.993A2.419 2.419 0 015.4 7.091l.457-.537a.326.326 0 01.557.13l.261 1.042h.258l1.1-1.1v-.76a3.57 3.57 0 011.052-2.541 1.441 1.441 0 011.018-.421h.7a1.394 1.394 0 01.992.412l.553.554h.832a.326.326 0 01.326.326v.8a1.126 1.126 0 01-1.128 1.118H11.9V7.7l.24 1.8a5.09 5.09 0 01.039.926 2.785 2.785 0 01-.6 1.593v1.975l3.04-2.016A7.541 7.541 0 0018 5.677v-.414a6.023 6.023 0 00-.208-1.573zM1.388 8.344a.326.326 0 01-.41-.2l-.05-.15A5.6 5.6 0 01.64 6.218v-.109a.326.326 0 11.643 0v.109a4.962 4.962 0 00.255 1.572l.05.149a.326.326 0 01-.2.407zm14.937 1.181l-.289.362a8.649 8.649 0 01-2.472 2.115l-.869.494a.326.326 0 01-.319-.558l.869-.494a8.009 8.009 0 002.29-1.954l.289-.362a.326.326 0 11.506.4zm1.035-3.309a5.6 5.6 0 01-.288 1.775l-.05.15a.326.326 0 01-.612-.2v.003l.05-.15a4.961 4.961 0 00.255-1.571v-.109a.326.326 0 11.643 0v.109zm0-1.392a.326.326 0 11-.643 0v-.326a.326.326 0 01.643 0z'
        />
        <path
          data-name='Path 5'
          d='M7.126 13.007l.4-.6a1.119 1.119 0 00.189-.624v-1.169a.326.326 0 01.326-.326.644.644 0 00.643-.643v-.356a1.52 1.52 0 01-.946-.644.642.642 0 00-.535-.287H6.43a.326.326 0 01-.312-.243l-.169-.679-.052.061a1.774 1.774 0 00-.434 1.078v1.072a.326.326 0 01-.054.178L3.78 12.271l.185.121.676.443 2.584 1.693-.118-.237a.326.326 0 01-.034-.143v-.964a.326.326 0 01.054-.174zM6.75 9.649v-.643h.645v.643z'
        />
        <path
          data-name='Path 6'
          d='M8.002 14.648a.325.325 0 01.034.144v.269l.326.211v-.99l-.359.359z'
        />
      </g>
    </svg>
  )
}

export const Purse = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 2'>
        <g
          data-name='Group 1'
          fill={color}
          stroke='#fff'
          strokeMiterlimit='10'
          strokeWidth='.091'
          transform='translate(-85.169 -7.348)'
        >
          <path
            data-name='Path 1'
            d='M98.946 11.381l.217-.061a5.124 5.124 0 00-.6-1.341 11.3 11.3 0 00-1.04-1.279 4.724 4.724 0 00-.93-.679l-.269-.143a3.735 3.735 0 00-.88-.323 5.437 5.437 0 00-1.274-.167l-.317.014a5.3 5.3 0 00-.957.152c-.1.024-.2.061-.3.092a5.009 5.009 0 00-.846.374 4.734 4.734 0 00-.93.679 5.709 5.709 0 00-1.639 2.615l.217.061.217.061a4.7 4.7 0 01.972-1.8 5.106 5.106 0 01.6-.508 4.982 4.982 0 01.874-.521 5.2 5.2 0 011.018-.35 5.315 5.315 0 011.1-.123 5.5 5.5 0 011.1.123 5.2 5.2 0 011.018.35 4.99 4.99 0 01.874.521 5.066 5.066 0 01.585.5 4.7 4.7 0 01.982 1.806z'
          />
          <path
            data-name='Path 2'
            d='M93.787 22.392a22.149 22.149 0 01-8.561-1.727l3.3-9.285h11.282l3.3 9.285a22.149 22.149 0 01-8.561 1.727z'
          />
          <path
            data-name='Path 3'
            d='M88.531 11.381l-1.353 3.8a17.645 17.645 0 006.609 1.351h.765a17.643 17.643 0 006.609-1.351l-1.353-3.8z'
          />
          <path
            data-name='Path 4'
            d='M88.531 11.23l-1.225 3.442a14.059 14.059 0 006.481 1.71h.765a14.059 14.059 0 006.481-1.71l-1.224-3.442z'
          />
          <rect
            data-name='Rectangle 26'
            width='2.01'
            height='2.01'
            rx='.672'
            transform='rotate(-44.999 66.026 -103.976)'
          />
          <path
            data-name='Path 5'
            d='M101.162 15.182h0l-.173-.486a14.034 14.034 0 01-6.436 1.687h-.273v.15h.272a17.649 17.649 0 006.61-1.351z'
          />
          <rect
            data-name='Rectangle 27'
            width='2.01'
            height='2.01'
            rx='.672'
            transform='rotate(-44.999 66.026 -103.976)'
          />
          <rect
            data-name='Rectangle 28'
            width='1.5'
            height='1.5'
            rx='.501'
            transform='rotate(-44.999 66.206 -104.411)'
          />
        </g>
      </g>
    </svg>
  )
}

export const ShavingNeeds = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 17'>
        <g data-name='Group 16'>
          <path
            data-name='Path 60'
            d='M17.24.609h-5.239a.741.741 0 00-.731.731v.667a.741.741 0 00.731.731h.183a1.222 1.222 0 011.222 1.222v1.222l-.152 3.351h2.777l-.183-3.351V3.959a1.222 1.222 0 011.222-1.222h.183a.741.741 0 00.731-.731v-.667a.741.741 0 00-.744-.731zm-2.011 4.265h-1.222v-.609h1.222zm.03-1.222h-1.28a1.741 1.741 0 00-.457-.914h2.163a1.952 1.952 0 00-.425.92z'
            fill={color}
          />
        </g>
      </g>
      <g data-name='Group 19'>
        <g data-name='Group 18'>
          <path
            data-name='Path 61'
            d='M16.023 9.138h-2.8l-.061 1.222h2.924z'
            fill={color}
          />
        </g>
      </g>
      <g data-name='Group 21'>
        <g data-name='Group 20'>
          <path
            data-name='Path 62'
            d='M16.413 16.144l-.243-5.178h-3.046l-.243 5.178a1.768 1.768 0 103.533 0z'
            fill={color}
          />
        </g>
      </g>
      <g data-name='Group 23'>
        <g data-name='Group 22'>
          <path
            data-name='Path 63'
            d='M8.499 1.827V0H2.436v2.742h-.918V4.11A2.283 2.283 0 000 6.274V7.31h6.092v7.31H0v1.066a2.3 2.3 0 002.284 2.285h3.934a2.282 2.282 0 002.284-2.284V6.244a2.312 2.312 0 00-1.526-2.163V2.742h-.915v-.915zM6.092 3.351h.3v.609h-4.26v-.609z'
            fill={color}
          />
        </g>
      </g>
      <g data-name='Group 25'>
        <g data-name='Group 24'>
          <path
            data-name='Path 64'
            d='M0 7.92v1.222h2.132a.304.304 0 110 .609H0v.914h3.655a.304.304 0 110 .609H0v.914h3.655a.304.304 0 110 .609H0v1.222h5.482V7.927z'
            fill={color}
          />
        </g>
      </g>
    </svg>
  )
}

export const Shirts = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g fill={color}>
        <path
          data-name='Path 109'
          d='M6.751 2.546a.172.172 0 00.04 0l2.206-.525 2.2.543a.171.171 0 00.041 0 .142.142 0 00.111-.051.149.149 0 00.027-.128l-.21-.983a.362.362 0 010-.115l.221-1.1a.144.144 0 00-.026-.122.138.138 0 00-.168-.029l-2.192 1.05L6.813.017a.137.137 0 00-.169.028.144.144 0 00-.027.122l.21 1.1a.362.362 0 010 .115l-.217.979a.149.149 0 00.027.128.142.142 0 00.11.053z'
        />
        <path
          data-name='Path 110'
          d='M2.563 15.126l-1.806-.153a.4.4 0 00-.4.278l-.342 1.214a.285.285 0 00.039.248.285.285 0 00.224.112l1.8.058h.013a.428.428 0 00.391-.288l.334-1.1a.282.282 0 00-.252-.372z'
        />
        <path
          data-name='Path 111'
          d='M17.985 16.466l-.338-1.2a.4.4 0 00-.4-.278l-1.806.152a.282.282 0 00-.252.372l.33 1.083a.428.428 0 00.391.288l1.815-.058a.274.274 0 00.264-.359z'
        />
        <path
          data-name='Path 112'
          d='M17.024 14.342a.286.286 0 00.257-.372l-.756-2.678a5.452 5.452 0 01-.105-.451l-1.321-6.627a.61.61 0 00-.315-.4l-2.139-.945a.63.63 0 00-.248-.046.638.638 0 00-.263.051L9.176 4.248a.483.483 0 01-.346 0L5.865 2.876a.64.64 0 00-.263-.051.63.63 0 00-.248.046l-2.139.945a.61.61 0 00-.315.4l-1.318 6.626c-.025.125-.074.328-.105.451l-.759 2.662a.286.286 0 00.257.372l1.824.154a.405.405 0 00.407-.275l.874-2.857a3.587 3.587 0 00.105-.476l.278-2.1-.254 8.162a.326.326 0 00.327.337h8.99a.325.325 0 00.326-.338l-.292-8.058.265 2.006a3.582 3.582 0 00.105.476l.875 2.874a.405.405 0 00.407.275zM8.998 16.3a.558.558 0 11.558-.558.558.558 0 01-.558.558zm0-2.422a.558.558 0 11.558-.558.558.558 0 01-.558.558zm0-2.422a.558.558 0 11.558-.558.558.558 0 01-.558.558zm0-2.422a.558.558 0 11.558-.558.558.558 0 01-.558.558zm0-2.422a.558.558 0 11.558-.558.558.558 0 01-.558.562z'
        />
      </g>
    </svg>
  )
}

export const ShoulderBags = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g
        data-name='Group 3'
        transform='translate(-100.548 -66.187)'
        fill={color}
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='.076'
      >
        <path
          data-name='Path 6'
          d='M105.083 69.531l-.917.243-.848-3.195a.149.149 0 01.068-.166h0a1.343 1.343 0 01.708-.188h0a.149.149 0 01.141.111z'
        />
        <path
          data-name='Path 7'
          d='M104.167 69.774l-.917.243-.848-3.195a.149.149 0 01.068-.166h0a1.342 1.342 0 01.708-.188h0a.149.149 0 01.141.111z'
        />
        <path
          data-name='Path 8'
          d='M106.5 69.531l.917.243.848-3.195a.149.149 0 00-.068-.166h0a1.343 1.343 0 00-.708-.188h0a.149.149 0 00-.141.111z'
        />
        <path
          data-name='Path 9'
          d='M107.421 69.774l.917.243.848-3.195a.149.149 0 00-.068-.166h0a1.342 1.342 0 00-.708-.188h0a.149.149 0 00-.141.111z'
        />
        <path
          data-name='Path 10'
          d='M110.987 80.15l-.645-7.545a3.781 3.781 0 00-3.768-3.459h-.78v1.23h0v-1.23h-.78a3.781 3.781 0 00-3.768 3.459l-.646 7.545a3.407 3.407 0 003.395 3.7h3.598a3.407 3.407 0 003.395-3.7z'
        />
        <path
          data-name='Path 11'
          d='M108.494 69.668c-1.336-.669-1.426-1.652-2.7-1.654h0c-1.272 0-1.362.985-2.7 1.654l.294-.046c1.191-.519 1.271-1.282 2.406-1.283s1.215.764 2.406 1.283z'
        />
        <path
          data-name='Path 12'
          d='M105.795 77.868l.132-.006 4.385-.192.239 2.792h0a16.8 16.8 0 01-4.579.636h-.177'
        />
        <path
          data-name='Path 13'
          d='M105.788 77.868l-.132-.006-4.385-.192-.239 2.792h0a16.8 16.8 0 004.579.636h.177'
        />
        <path
          data-name='Path 14'
          d='M110.625 80.455l-.591-6.916a3.54 3.54 0 00-3.527-3.239h-1.427a3.54 3.54 0 00-3.527 3.238l-.591 6.916a3.2 3.2 0 001.393 2.92l.083-.123a3.056 3.056 0 01-1.328-2.785l.591-6.916a3.372 3.372 0 013.38-3.1h1.426a3.372 3.372 0 013.379 3.1l.591 6.916a3.056 3.056 0 01-1.328 2.785l.083.123a3.2 3.2 0 001.392-2.921z'
        />
        <path
          data-name='Path 15'
          d='M105.792 84.149v-3.008h0a25.049 25.049 0 01-4.756-.676l-.447-.039A3.568 3.568 0 00104 84.149z'
        />
        <path
          data-name='Path 16'
          d='M105.795 81.141v3.008h1.8A3.568 3.568 0 00111 80.426l-.447.039a25.083 25.083 0 01-4.758.676z'
        />
        <path
          data-name='Path 17'
          d='M105.792 81.083v2.767h1.647a3.123 3.123 0 003.112-3.389 27.2 27.2 0 01-4.757.622z'
        />
        <path
          data-name='Path 18'
          d='M105.795 83.85v-2.765h0a27.157 27.157 0 01-4.759-.622h0a3.123 3.123 0 003.112 3.389z'
        />
        <rect
          data-name='Rectangle 34'
          width='2.177'
          height='1.086'
          rx='.281'
          transform='rotate(-3.21 1460.138 -1873.834)'
        />
        <path
          data-name='Path 19'
          d='M103.251 80.12h0a.158.158 0 01-.158-.158v-6.679a.158.158 0 01.158-.158h0a.158.158 0 01.158.158v6.679a.158.158 0 01-.158.158z'
        />
        <path data-name='Rectangle 35' d='M103.093 74.874h.316v1.036h-.316z' />
      </g>
    </svg>
  )
}

export const Skirts = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g fill={color}>
        <path
          data-name='Path 107'
          d='M17.688 16.585L14.826 5.454a3.95 3.95 0 00-.26-.682l-.822-1.6a.749.749 0 00-.616-.376H4.576a.746.746 0 00-.615.377l-.841 1.65a4.017 4.017 0 00-.258.683L.017 16.585a.373.373 0 00.374.482h.64a1.52 1.52 0 01.612.158l1.246.691a.824.824 0 00.728 0l1.24-.691a.607.607 0 01.514 0l1.246.691a.824.824 0 00.728 0l1.246-.691a.607.607 0 01.514 0l1.246.691a.824.824 0 00.728 0l1.246-.691a.607.607 0 01.514 0l1.246.691a.824.824 0 00.728 0l1.246-.691a1.52 1.52 0 01.612-.158h.64a.373.373 0 00.374-.482z'
        />
        <path
          data-name='Path 108'
          d='M4.525 2.1h8.656a.333.333 0 00.333-.333V.333A.333.333 0 0013.181 0H4.525a.333.333 0 00-.331.333v1.438a.333.333 0 00.331.331zM7.833.652a.267.267 0 01.262-.266h1.508a.267.267 0 01.266.266v.8a.267.267 0 01-.266.266H8.095a.267.267 0 01-.266-.266z'
        />
        <path data-name='Rectangle 2' d='M8.275.83h1.153v.444H8.275z' />
      </g>
    </svg>
  )
}

export const Snacks = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g fill={color}>
        <path
          data-name='Path 36'
          d='M2.109 5.274H12.66a1.055 1.055 0 000-2.11h-.1a1.67 1.67 0 00-1.5-1.054 2.626 2.626 0 00-1.854-1.044 2.1 2.1 0 00-3.653 0 2.626 2.626 0 00-1.85 1.045h-.011a1.577 1.577 0 00-1.481 1.055h-.1a1.055 1.055 0 100 2.11z'
        />
        <path
          data-name='Path 37'
          d='M7.956 15.891l.863-9.562H5.946l.862 9.562z'
        />
        <path
          data-name='Path 38'
          d='M2.884 12.881a2.118 2.118 0 011.253 1.378 2.626 2.626 0 011.07 1.633h.542L4.887 6.33H2.164z'
        />
        <path
          data-name='Path 39'
          d='M12.601 6.329H9.877l-.862 9.562h2.059a.527.527 0 00.524-.469z'
        />
        <path
          data-name='Path 40'
          d='M1.054 16.946a.876.876 0 00.091-.019 1.577 1.577 0 102-2c0-.031.019-.058.019-.091a1.055 1.055 0 00-2.11 0 1.055 1.055 0 100 2.109z'
        />
      </g>
    </svg>
  )
}

export const Tops = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g fill={color}>
        <path
          data-name='Path 104'
          d='M6.994 2.83L5.928 5.991a.315.315 0 01-.6 0L4.273 2.83a2.4 2.4 0 00-2.909-.026L0 3.822l.087.329a32.647 32.647 0 01.909 11.921L.79 18h9.7l-.215-1.909a32.667 32.667 0 01.912-11.96l.083-.31-1.366-1.013a2.4 2.4 0 00-2.909.026zm0 0'
        />
        <path
          data-name='Path 105'
          d='M.549 2.843l.62-.114L.714.261a.315.315 0 00-.62.114zm0 0'
        />
        <path
          data-name='Path 106'
          d='M10.978.369a.316.316 0 00-.622-.108L9.966 2.6l.622.108zm0 0'
        />
      </g>
    </svg>
  )
}

export const Wallet = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 9'>
        <g data-name='Group 8'>
          <path
            data-name='Path 42'
            d='M12.362 1.129a1.415 1.415 0 00-1.672-1.1L1.428 1.942h11.1z'
            fill={color}
          />
        </g>
        <path
          data-name='Path 43'
          d='M11.579 11.242v-2.2a1.822 1.822 0 011.82-1.82h2.784v-2.78a1.415 1.415 0 00-1.415-1.415H1.415A1.415 1.415 0 000 4.442v11.4a1.415 1.415 0 001.415 1.415h13.354a1.415 1.415 0 001.415-1.415v-2.776h-2.785a1.822 1.822 0 01-1.82-1.82z'
          fill={color}
        />
        <path
          data-name='Path 44'
          d='M16.989 8.03h-3.59a1.011 1.011 0 00-1.01 1.01v2.2a1.012 1.012 0 001.01 1.01h3.59a1.012 1.012 0 001.01-1.01v-2.2a1.012 1.012 0 00-1.01-1.01zm-2.8 3.128a1.006 1.006 0 111.006-1.006 1.006 1.006 0 01-1.006 1.006z'
          fill={color}
        />
      </g>
    </svg>
  )
}

export const WomenDress = ({
  color = 'currentColor',
  width = '18px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <defs>
        <clipPath id='a'>
          <path
            data-name='Rectangle 20'
            transform='translate(226 1073)'
            fill='#ebe7e7'
            d='M0 0h18v18H0z'
          />
        </clipPath>
      </defs>
      <g
        data-name='Women Dress'
        transform='translate(-226 -1073)'
        clipPath='url(#a)'
      >
        <g
          data-name='Group 28'
          transform='translate(230.461 1073)'
          fill={color}
        >
          <path
            data-name='Path 80'
            d='M8.236 12.619c-.12-.6-.384-3.422-1.008-4.358a1.446 1.446 0 01-.19-.8.039.039 0 000-.007c.02-.29.052-.6.073-.762a.493.493 0 01.01-.076c.016-.1.036-.192.057-.289a16.065 16.065 0 00.515-2.746c0-1.429-.733-1.849-.733-1.849.251-1.069.434-1.647.434-1.647L7.179 0A10.558 10.558 0 006.7 1.717a2.911 2.911 0 01-2.161.694 2.913 2.913 0 01-2.161-.694A10.578 10.578 0 001.897 0l-.216.087s.18.577.434 1.647c0 0-.733.421-.733 1.849a14.672 14.672 0 00.491 2.631.1.1 0 000 .039.2.2 0 00.01.035l.007.028c.03.123.074.347.081.347.014.087.029.243.043.4.006.055.01.109.014.163l.016.207h-.007a1.462 1.462 0 01-.191.826c-.624.936-.889 3.758-1.008 4.358s-.408 2.81-.552 3.459-.288 1.537-.288 1.537a3.7 3.7 0 001.2.144s-.087.252.649.18a14.433 14.433 0 011.969-.06c.5.024.153.12.72.12s.216-.1.72-.12a14.388 14.388 0 011.969.06c.733.072.649-.18.649-.18a3.708 3.708 0 001.2-.144s-.144-.889-.289-1.537-.428-2.857-.549-3.457zM6.955 6.468c-.056.077-.106.2-.041.251-.017.115-.027.231-.039.347-.065-.075-.274-.006-.274-.006-.155-.068.137.335.254.181-.005.065-.007.13-.01.2-.142-.01-.284-.02-.427-.028a.66.66 0 00-.068-.149c.016-.108-.108.016-.15.137a25.847 25.847 0 00-.925-.02C5.211 7.304 5 7.373 5 7.373c-.031-.014-.044-.008-.044.009h-.032a.147.147 0 00.016-.067.152.152 0 00-.3 0 .149.149 0 00.017.067c-.406 0-.812.013-1.214.023a.791.791 0 00-.042-.077c.014-.092-.074-.017-.126.081l-.207.005a.491.491 0 00.112-.2c.154-.1-.434-.074-.271.151a.2.2 0 00.051.051h-.173a.087.087 0 000-.122c-.136-.2-.238.094-.25.127l-.3.006a.43.43 0 00-.005-.081c.073-.011.315-.308.087-.354a.173.173 0 00-.109.005 4.818 4.818 0 00-.048-.385.674.674 0 00.059-.135c.067-.042-.005-.062-.1-.051a2.26 2.26 0 00-.039-.147h.224a.152.152 0 10.292.057.148.148 0 00-.014-.062l1.04-.019a.1.1 0 000 .132c.143.2.244-.072.266-.137l.479-.005c.075.095.22.2.277.043a.207.207 0 00.009-.046h.7a.15.15 0 00-.034.092.152.152 0 10.3 0 .149.149 0 00-.033-.087c.384.007.766.024 1.148.048-.116.015-.254.077-.166.2.161.225.271-.151.271-.151.029-.018.032-.032.018-.042l.1.007a.042.042 0 00.009.008c-.007.052-.016.1-.026.153z'
          />
          <path
            data-name='Path 81'
            d='M4.951 7.161c-.144.087.4.076.252-.134s-.252.134-.252.134z'
          />
          <path
            data-name='Path 82'
            d='M4.286 7.052c-.1.235.249.14.249.14.15.075-.149-.375-.249-.14z'
          />
          <path
            data-name='Path 83'
            d='M4.768 6.721c-.284-.057-.1.31-.1.31-.049.19.384-.249.1-.31z'
          />
          <path
            data-name='Path 84'
            d='M5.973 6.533c.095-.26-.277-.138-.277-.138-.167-.073.183.398.277.138z'
          />
          <path
            data-name='Path 85'
            d='M5.382 6.898c.276.023.061-.3.061-.3.027-.184-.34.279-.061.3z'
          />
          <path
            data-name='Path 86'
            d='M4.985 6.632c.161.225.271-.151.271-.151.154-.097-.433-.076-.271.151z'
          />
          <circle
            data-name='Ellipse 3'
            cx='.152'
            cy='.152'
            r='.152'
            transform='translate(3.253 6.916)'
          />
          <path
            data-name='Path 87'
            d='M3.851 6.782c-.144-.21-.252.134-.252.134-.144.086.396.076.252-.134z'
          />
          <path
            data-name='Path 88'
            d='M3.649 7.126c-.167-.073.183.4.277.138s-.277-.138-.277-.138z'
          />
          <path
            data-name='Path 89'
            d='M2.903 6.808c-.1.235.249.14.249.14.151.075-.149-.374-.249-.14z'
          />
          <path
            data-name='Path 90'
            d='M3.384 6.48c-.284-.057-.1.31-.1.31-.046.185.385-.256.1-.31z'
          />
          <path
            data-name='Path 91'
            d='M6.359 6.852a.152.152 0 11-.152.152.152.152 0 01.152-.152z'
          />
          <path
            data-name='Path 92'
            d='M6.553 6.853c-.144.087.4.076.252-.134s-.252.134-.252.134z'
          />
          <path
            data-name='Path 93'
            d='M5.861 7.3c.161.225.271-.151.271-.151.152-.1-.435-.074-.271.151z'
          />
          <path
            data-name='Path 94'
            d='M5.856 6.744c-.1.235.249.14.249.14.15.075-.15-.375-.249-.14z'
          />
          <path
            data-name='Path 95'
            d='M6.338 6.413c-.284-.057-.1.31-.1.31-.049.187.385-.25.1-.31z'
          />
          <path
            data-name='Path 96'
            d='M4.064 6.654c.276.023.061-.3.061-.3.027-.184-.339.276-.061.3z'
          />
          <path
            data-name='Path 97'
            d='M2.972 6.533c.094-.26-.277-.138-.277-.138-.168-.073.182.398.277.138z'
          />
          <path
            data-name='Path 98'
            d='M2.381 6.898c.276.023.061-.3.061-.3.026-.184-.336.279-.061.3z'
          />
        </g>
      </g>
    </svg>
  )
}

export const Google = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16.677'
      height='17'
      viewBox='0 0 16.677 17'
    >
      <path
        id='_ionicons_svg_logo-google'
        d='M68.579,55.29l-.086-.364H60.584v3.348h4.725a4.73,4.73,0,0,1-4.627,3.556,5.533,5.533,0,0,1-3.724-1.484,5.316,5.316,0,0,1-1.586-3.752,5.483,5.483,0,0,1,1.557-3.748,5.3,5.3,0,0,1,3.7-1.447,4.825,4.825,0,0,1,3.147,1.226l2.379-2.367a8.417,8.417,0,0,0-5.6-2.158A8.391,8.391,0,0,0,52,56.6,8.541,8.541,0,0,0,54.326,62.5a8.873,8.873,0,0,0,6.4,2.6,7.891,7.891,0,0,0,5.747-2.416,8.486,8.486,0,0,0,2.207-5.878,9.788,9.788,0,0,0-.1-1.516Z'
        transform='translate(-52 -48.1)'
        fill='currentColor'
      />
    </svg>
  )
}

export const Facebook = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='17'
      viewBox='0 0 17 17'
    >
      <path
        id='_ionicons_svg_logo-facebook_1_'
        data-name='_ionicons_svg_logo-facebook (1)'
        d='M80.061,64H64.939a.939.939,0,0,0-.939.939V80.061a.939.939,0,0,0,.939.939H72.5V74.271H70.468V71.792H72.5V69.959a3.23,3.23,0,0,1,3.484-3.391c.939,0,1.948.071,2.183.1v2.293H76.6c-1.067,0-1.271.5-1.271,1.248v1.58h2.541l-.332,2.479H75.333V81h4.728A.939.939,0,0,0,81,80.061V64.939A.939.939,0,0,0,80.061,64Z'
        transform='translate(-64 -64)'
        fill='currentColor'
      />
    </svg>
  )
}

export const MinusSquareO = ({ color, ...props }) => (
  <svg {...props} viewBox='64 -65 897 897'>
    <g>
      <path
        d='M888 760v0v0v-753v0h-752v0v753v0h752zM888 832h-752q-30 0 -51 -21t-21 -51v-753q0 -29 21 -50.5t51 -21.5h753q29 0 50.5 21.5t21.5 50.5v753q0 30 -21.5 51t-51.5 21v0zM732 347h-442q-14 0 -25 10.5t-11 25.5v0q0 15 11 25.5t25 10.5h442q14 0 25 -10.5t11 -25.5v0
  q0 -15 -11 -25.5t-25 -10.5z'
        fill={color}
      />
    </g>
  </svg>
)

export const PlusSquareO = ({ color, ...props }) => (
  <svg {...props} viewBox='64 -65 897 897'>
    <g>
      <path
        d='M888 760v0v0v-753v0h-752v0v753v0h752zM888 832h-752q-30 0 -51 -21t-21 -51v-753q0 -29 21 -50.5t51 -21.5h753q29 0 50.5 21.5t21.5 50.5v753q0 30 -21.5 51t-51.5 21v0zM732 420h-184v183q0 15 -10.5 25.5t-25.5 10.5v0q-14 0 -25 -10.5t-11 -25.5v-183h-184
  q-15 0 -25.5 -11t-10.5 -25v0q0 -15 10.5 -25.5t25.5 -10.5h184v-183q0 -15 11 -25.5t25 -10.5v0q15 0 25.5 10.5t10.5 25.5v183h184q15 0 25.5 10.5t10.5 25.5v0q0 14 -10.5 25t-25.5 11z'
        fill={color}
      />
    </g>
  </svg>
)

export const CloseSquareO = ({ color, ...props }) => (
  <svg {...props} viewBox='64 -65 897 897'>
    <g>
      <path
        d='M717.5 589.5q-10.5 10.5 -25.5 10.5t-26 -10l-154 -155l-154 155q-11 10 -26 10t-25.5 -10.5t-10.5 -25.5t11 -25l154 -155l-154 -155q-11 -10 -11 -25t10.5 -25.5t25.5 -10.5t26 10l154 155l154 -155q11 -10 26 -10t25.5 10.5t10.5 25t-11 25.5l-154 155l154 155
  q11 10 11 25t-10.5 25.5zM888 760v0v0v-753v0h-752v0v753v0h752zM888 832h-752q-30 0 -51 -21t-21 -51v-753q0 -29 21 -50.5t51 -21.5h753q29 0 50.5 21.5t21.5 50.5v753q0 30 -21.5 51t-51.5 21v0z'
        fill={color}
      />
    </g>
  </svg>
)

// SVG plus icon
export const Plus = ({ color = 'currentColor', width = 12, height = 12 }) => {
  return (
    <span>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width}
        height={height}
        viewBox='0 0 12 12'
      >
        <path
          id='_ionicons_svg_ios-add_7_'
          data-name='_ionicons_svg_ios-add (7)'
          d='M138.753,132.753h-4.506v-4.506a.747.747,0,1,0-1.494,0v4.506h-4.506a.747.747,0,0,0,0,1.494h4.506v4.506a.747.747,0,1,0,1.494,0v-4.506h4.506a.747.747,0,1,0,0-1.494Z'
          transform='translate(-127.5 -127.5)'
          fill={color}
        />
      </svg>
    </span>
  )
}

// SVG minus icon
export const Minus = ({ color = 'currentColor', width = 12, height = 1.5 }) => {
  return (
    <span>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width}
        height={height}
        viewBox='0 0 12 1.494'
      >
        <path
          id='_ionicons_svg_ios-remove_4_'
          data-name='_ionicons_svg_ios-remove (4)'
          d='M138.753,240H128.247a.747.747,0,0,0,0,1.494h10.506a.747.747,0,1,0,0-1.494Z'
          transform='translate(-127.5 -240)'
          fill={color}
        />
      </svg>
    </span>
  )
}

// SVG Cart icon
export const CartIcon = ({
  color = 'currentColor',
  width = 14,
  height = 12
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 14.4 12'
    >
      <g
        id='Group_120'
        data-name='Group 120'
        transform='translate(-288 -413.89)'
      >
        <path
          id='Path_154'
          data-name='Path 154'
          fill={color}
          d='M298.7,418.289l-2.906-4.148a.835.835,0,0,0-.528-.251.607.607,0,0,0-.529.251l-2.905,4.148h-3.17a.609.609,0,0,0-.661.625v.191l1.651,5.84a1.336,1.336,0,0,0,1.255.945h8.588a1.261,1.261,0,0,0,1.254-.945l1.651-5.84v-.191a.609.609,0,0,0-.661-.625Zm-5.419,0,1.984-2.767,1.98,2.767Zm1.984,5.024a1.258,1.258,0,1,1,1.319-1.258,1.3,1.3,0,0,1-1.319,1.258Zm0,0'
        />
      </g>
    </svg>
  )
}

// SVG Grocery icon
export const GroceryIcon = ({
  color = 'currentColor',
  width = 14,
  height = 16
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 14 16'
    >
      <g id='Group_69' data-name='Group 69' transform='translate(0 0)'>
        <path
          id='Path_112'
          data-name='Path 112'
          d='M302.952,415.83a.326.326,0,0,0,.1.016.3.3,0,0,0,.287-.207.533.533,0,0,1,.675-.332,1.139,1.139,0,0,0,1.443-.71.3.3,0,1,0-.573-.2.533.533,0,0,1-.675.332,1.142,1.142,0,0,0-1.443.712.3.3,0,0,0,.189.384Zm0,0'
          transform='translate(-293.38 -408.637)'
          fill={color}
        />
        <path
          id='Path_113'
          data-name='Path 113'
          d='M304.847,410.255a.31.31,0,0,0,.1.015.3.3,0,0,0,.287-.2.532.532,0,0,1,.675-.332,1.138,1.138,0,0,0,1.442-.712.3.3,0,1,0-.572-.194.533.533,0,0,1-.675.332,1.139,1.139,0,0,0-1.443.712.3.3,0,0,0,.189.384Zm0,0'
          transform='translate(-294.558 -405.009)'
          fill={color}
        />
        <g id='Group_68' data-name='Group 68'>
          <path
            id='Path_114'
            data-name='Path 114'
            d='M306.737,404.967a.312.312,0,0,0,.1.015.3.3,0,0,0,.287-.205.4.4,0,0,1,.5-.245,1,1,0,0,0,1.266-.625.3.3,0,1,0-.573-.194.387.387,0,0,1-.2.226.393.393,0,0,1-.3.019,1,1,0,0,0-1.266.623.3.3,0,0,0,.189.385Zm0,0'
            transform='translate(-295.734 -401.531)'
            fill={color}
          />
          <path
            id='Path_115'
            data-name='Path 115'
            d='M292,405.326a18.15,18.15,0,0,0,1.006-5.3,1.918,1.918,0,0,0-.582-1.376,1.4,1.4,0,0,0-1.6-.212c-.93.433-1.6,1.711-2.128,2.736q-.046.089-.091.173a1.664,1.664,0,0,0-.986-1.129,1.42,1.42,0,0,0-1.153-1.038.631.631,0,0,0-.024-.088,1.048,1.048,0,0,0-.889-.686,1.133,1.133,0,0,0-.662.122,1.209,1.209,0,0,0-.55-.129,1.127,1.127,0,0,0-1.114.8,1.3,1.3,0,0,0-1.03,1.207,1.443,1.443,0,0,0-1.167,1.367,1.3,1.3,0,0,0,.106.509,1.036,1.036,0,0,0-.273.7,1.025,1.025,0,0,0,.1.441,1.716,1.716,0,0,0-1.239-.542.282.282,0,1,0,.009.563.288.288,0,0,0,.03,0,1.114,1.114,0,0,1,.759.377,2.148,2.148,0,0,0-1.365.813,1.315,1.315,0,0,0-.076,1.034.442.442,0,0,0-.076.281l.529,6.812a1.705,1.705,0,0,0,1.771,1.523h8.733a1.7,1.7,0,0,0,1.77-1.518l.542-7.053a.347.347,0,0,0-.111-.274.416.416,0,0,0-.242-.109Zm-3.14-3.173c.123-.208.257-.466.4-.74.468-.9,1.108-2.129,1.849-2.476a.722.722,0,0,1,.869.1,1.386,1.386,0,0,1,.407.968,17.688,17.688,0,0,1-1,5.209c-.02.059-.065.177-.129.341l-.53.213-.033.015a1.054,1.054,0,0,1-.992,0l-.222-.119a1.736,1.736,0,0,0-.828-.208,1.87,1.87,0,0,0-.234.017,1.693,1.693,0,0,0-.614.191l-.222.121a1.055,1.055,0,0,1-.4.112c.006-.022.015-.043.021-.063q.13-.4.277-.788c.035-.1.073-.19.109-.285.082-.206.167-.411.254-.613.038-.087.075-.173.113-.26a17.883,17.883,0,0,1,.9-1.74Zm-3.6,3.332c-.033.006-.068.011-.1.019a1.722,1.722,0,0,0-.3.087l-.061-.247c.09.007.179.014.263.014a2.56,2.56,0,0,0,1.481-.47,4.033,4.033,0,0,1,.431-.242c-.029.073-.056.146-.084.22-.02.054-.042.1-.061.158q-.139.376-.26.759l-.208-.113a1.742,1.742,0,0,0-.826-.208,1.694,1.694,0,0,0-.223.017c-.017,0-.034.005-.052.007Zm-.494-3.806a.131.131,0,0,1-.153-.089.118.118,0,0,1,.1-.138l1.745-.344a.13.13,0,0,1,.126.092.109.109,0,0,1-.018.088.134.134,0,0,1-.08.051Zm.123,1.143c.036-.043.071-.084.1-.125a.523.523,0,0,0,.065-.091.551.551,0,0,0,.058-.419l1.3-.257a.622.622,0,0,0,.033.1.661.661,0,0,0,.307.312l.147.071.126.062.062.03c.036.018.071.038.108.059l.091.053c.035.022.068.047.1.07s.058.045.085.069.058.053.085.082a.977.977,0,0,1,.132.171c-.132.263-.257.532-.377.8-.018.043-.038.082-.056.125a3.293,3.293,0,0,0-1.077.487,1.975,1.975,0,0,1-1.524.336l-.19-.784a1.213,1.213,0,0,1,.42-1.159Zm-1.843,7a.283.283,0,1,1,0,.564h-2.178a.283.283,0,1,1,0-.564Zm-2.178,1.126h2.8a.283.283,0,1,1,0,.564h-2.8a.283.283,0,1,1,0-.564Zm.837-8.4.2-.153-.132-.206a.778.778,0,0,1-.128-.424.888.888,0,0,1,.9-.847l.378-.015-.088-.333a.615.615,0,0,1-.023-.162.733.733,0,0,1,.713-.7l.287-.02v-.279a.5.5,0,0,1,.523-.458.537.537,0,0,1,.346.124l.219.179.21-.187a.454.454,0,0,1,.363-.111.437.437,0,0,1,.365.286.339.339,0,0,1,.015.15l-.037.315h.351a.825.825,0,0,1,.851.719l.015.186.193.061a1.085,1.085,0,0,1,.795,1.038.946.946,0,0,1-.2.558,3.375,3.375,0,0,0-.621-.358c-.049-.023-.1-.045-.143-.07a.064.064,0,0,1-.037-.048.16.16,0,0,1,.044-.125.562.562,0,0,0,.146-.52l-.038-.155a.678.678,0,0,0-.789-.458l-.083.017h0l-.913.181-.89.176a.6.6,0,0,0-.506.714l.018.077h0l.018.076a.622.622,0,0,0,.386.422.18.18,0,0,1,.1.091c.007.021,0,.032-.015.058s-.064.076-.1.115-.07.081-.107.124l-.032.041c-.027.033-.053.066-.08.1l-.039.054c-.024.034-.047.069-.07.1-.014.019-.026.039-.038.059a1.2,1.2,0,0,0-.065.125l-.028.052a1.551,1.551,0,0,0-.071.194.26.26,0,0,1-.006.032,1.375,1.375,0,0,0-.035.18c0,.025,0,.051-.006.077s-.008.065-.008.1l-.026-.03-.063-.069c-.046-.052-.092-.1-.138-.147l-.068-.066c-.049-.044-.1-.085-.147-.125l-.054-.044a2.1,2.1,0,0,0-.2-.128c-.02-.011-.041-.02-.061-.03-.049-.025-.1-.047-.146-.066-.028-.011-.055-.019-.081-.027a1.3,1.3,0,0,0-.134-.036c-.027-.006-.055-.012-.082-.017a1.217,1.217,0,0,0-.17-.015l-.039,0a1.736,1.736,0,0,0-.88.268.52.52,0,0,1-.042-.2.528.528,0,0,1,.222-.424Zm-2,2.338a1.582,1.582,0,0,1,1.006-.539,1.735,1.735,0,0,0,.7-.362c.086-.074.168-.14.247-.2s.14-.1.205-.136l.007-.006a1.33,1.33,0,0,1,.363-.153l.014,0a.745.745,0,0,1,.161-.019c.392,0,.811.353,1.247,1.051a1.958,1.958,0,0,1,.206,1.375l-.07-.008a1.04,1.04,0,0,1-.316-.1l-.222-.121a1.752,1.752,0,0,0-.828-.208,1.954,1.954,0,0,0-.848.208l-.108.059a1.3,1.3,0,0,1-1.22,0l-.419-.228a.566.566,0,0,0-.175-.059.735.735,0,0,1,.051-.548Zm4.585,7.747h-3.423a.282.282,0,1,1,0-.562h3.423a.283.283,0,1,1,0,.562Zm1.867,0h-.623a.282.282,0,1,1,0-.562h.623a.283.283,0,1,1,0,.562Zm0,0'
            transform='translate(-279.002 -398.28)'
            fill={color}
          />
        </g>
      </g>
    </svg>
  )
}

export const MakeupIcon = ({
  color = 'currentColor',
  width = 12,
  height = 16
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 11.401 16'
    >
      <g id='lipstick' transform='translate(-0.004)'>
        <path
          id='Path_2031'
          data-name='Path 2031'
          d='M20.758,112.77v2.76h3.383v-2.352a2.422,2.422,0,0,1-1.367.409A3.01,3.01,0,0,1,20.758,112.77Zm0,0'
          transform='translate(-20.105 -109.246)'
          fill={color}
        />
        <path
          id='Path_2032'
          data-name='Path 2032'
          d='M4.228,233.031H.408a.4.4,0,0,0-.4.4v7.909a.4.4,0,0,0,.4.4h3.82a.4.4,0,0,0,.4-.4v-7.909A.4.4,0,0,0,4.228,233.031Zm0,0'
          transform='translate(0 -225.749)'
          fill={color}
        />
        <path
          id='Path_2033'
          data-name='Path 2033'
          d='M216.715,453.338a.4.4,0,0,0,.4.4h3.82a.4.4,0,0,0,.4-.4v-1.475h-4.629Zm0,0'
          transform='translate(-209.939 -437.743)'
          fill={color}
        />
        <path
          id='Path_2034'
          data-name='Path 2034'
          d='M220.939,233.031h-3.82a.4.4,0,0,0-.4.4v5.494h4.629v-5.494A.4.4,0,0,0,220.939,233.031Zm0,0'
          transform='translate(-209.939 -225.749)'
          fill={color}
        />
        <path
          id='Path_2035'
          data-name='Path 2035'
          d='M22.7.482a1.7,1.7,0,0,0-2.381.006,1.7,1.7,0,0,0,.431,2.342,1.7,1.7,0,0,0,2.381-.006A1.7,1.7,0,0,0,22.7.482Zm0,0'
          transform='translate(-19.381)'
          fill={color}
        />
      </g>
    </svg>
  )
}

export const MedicineIcon = ({
  color = 'currentColor',
  width = 16,
  height = 16
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16 16.001'
    >
      <g
        id='Group_175'
        data-name='Group 175'
        transform='translate(553.392 -314.288)'
      >
        <path
          id='Path_178'
          data-name='Path 178'
          d='M-541.294,317.863a3.621,3.621,0,0,1-1.017,2.627c-1.62,1.639-3.24,3.28-4.891,4.888a3.655,3.655,0,0,1-6.033-1.643,3.5,3.5,0,0,1,.907-3.579q2.366-2.417,4.782-4.784a3.491,3.491,0,0,1,3.662-.9,3.536,3.536,0,0,1,2.514,2.77A4.929,4.929,0,0,1-541.294,317.863Zm-4.4,3.7c.791-.786,1.6-1.527,2.329-2.336a1.853,1.853,0,0,0,.293-2.017,2.042,2.042,0,0,0-3.36-.669q-2.632,2.617-5.252,5.247a1.289,1.289,0,0,0-.09.1.594.594,0,0,0,.321.955.622.622,0,0,0,.625-.21q1.47-1.474,2.944-2.945c.048-.048.1-.094.166-.158Z'
          fill={color}
        />
        <path
          id='Path_179'
          data-name='Path 179'
          d='M-408.46,467.03l1.364-.817a3.95,3.95,0,0,0,4.856,2.139,3.856,3.856,0,0,0,2.756-3.015h-6.746c.067-.075.1-.12.145-.162.444-.445.884-.893,1.336-1.329a.464.464,0,0,1,.292-.12c1.533-.007,3.066-.005,4.6-.005h.367a4.05,4.05,0,0,0-2.268-2.837l.83-1.383a5.562,5.562,0,0,1,3.106,5.582,5.621,5.621,0,0,1-4.764,5.019A5.6,5.6,0,0,1-408.46,467.03Z'
          transform='translate(-139.595 -139.873)'
          fill={color}
        />
      </g>
    </svg>
  )
}

export const DressIcon = ({
  color = 'currentColor',
  width = 8,
  height = 16
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 8.069 16'
    >
      <g id='Group_2483' data-name='Group 2483' transform='translate(0)'>
        <path
          id='Path_2037'
          data-name='Path 2037'
          d='M128.461,11.218c-.107-.534-.341-3.042-.9-3.875a1.286,1.286,0,0,1-.169-.714.035.035,0,0,0,0-.006c.018-.257.046-.531.065-.677,0-.026.007-.051.01-.067.014-.086.033-.171.051-.257h0a14.282,14.282,0,0,0,.458-2.441c0-1.27-.651-1.644-.651-1.644.224-.95.384-1.462.384-1.462L127.522,0a9.387,9.387,0,0,0-.427,1.526,2.588,2.588,0,0,1-1.921.619,2.59,2.59,0,0,1-1.921-.619A9.4,9.4,0,0,0,122.825,0l-.192.075s.16.512.384,1.462c0,0-.651.374-.651,1.644a13.042,13.042,0,0,0,.437,2.339.086.086,0,0,0,0,.035c0,.008.006.019.009.031l.006.024c.027.109.066.3.072.311.013.077.027.216.039.358.005.049.009.1.012.145.005.068.01.132.014.184h-.006a1.3,1.3,0,0,1-.17.735c-.555.833-.79,3.341-.9,3.874s-.363,2.5-.491,3.074-.256,1.367-.256,1.367a3.288,3.288,0,0,0,1.068.128s-.075.224.576.16a12.831,12.831,0,0,1,1.75-.054c.448.021.135.107.64.107s.192-.085.64-.107a12.79,12.79,0,0,1,1.751.054c.651.064.576-.16.576-.16a3.3,3.3,0,0,0,1.067-.128s-.128-.79-.256-1.367S128.568,11.752,128.461,11.218Zm-1.139-5.467c-.05.069-.094.177-.036.224-.015.1-.024.206-.034.309-.058-.066-.243-.006-.243-.006-.138-.06.121.3.226.161,0,.058-.006.115-.009.173-.126-.009-.253-.018-.38-.025a.586.586,0,0,0-.061-.133c.014-.1-.1.014-.134.122-.273-.011-.547-.016-.822-.018-.057-.068-.244-.007-.244-.007-.028-.012-.04-.007-.039.008h-.028a.13.13,0,0,0,.015-.059.135.135,0,0,0-.27,0,.133.133,0,0,0,.015.06c-.361,0-.721.012-1.081.021a.7.7,0,0,0-.037-.069c.012-.082-.065-.015-.112.073l-.184,0a.436.436,0,0,0,.1-.178c.137-.086-.384-.065-.241.134a.182.182,0,0,0,.045.046l-.151,0a.078.078,0,0,0,0-.109c-.121-.176-.212.084-.222.114l-.263.006c0-.024,0-.048,0-.072.065-.01.28-.273.075-.315a.151.151,0,0,0-.1,0c-.01-.115-.024-.229-.043-.342a.6.6,0,0,0,.052-.12c.06-.037,0-.054-.085-.046-.01-.044-.022-.087-.035-.13l.2,0a.135.135,0,1,0,.26.051.132.132,0,0,0-.012-.055l.926-.017a.085.085,0,0,0,0,.117c.127.177.217-.064.236-.122l.426,0c.066.084.2.175.246.038a.184.184,0,0,0,.008-.041c.208,0,.417,0,.624,0a.133.133,0,0,0-.03.082.135.135,0,1,0,.27,0,.132.132,0,0,0-.029-.08c.342.006.681.022,1.021.042-.1.013-.226.069-.147.179.143.2.241-.134.241-.134.026-.016.028-.029.016-.037l.091.006s0,.005.007.007C127.34,5.661,127.331,5.706,127.322,5.751Z'
          transform='translate(-121.139)'
          fill={color}
        />
        <path
          id='Path_2038'
          data-name='Path 2038'
          d='M254.937,189.152c-.128.076.352.067.224-.119S254.937,189.152,254.937,189.152Z'
          transform='translate(-250.536 -182.787)'
          fill={color}
        />
        <path
          id='Path_2039'
          data-name='Path 2039'
          d='M237.086,189.725c-.088.209.221.124.221.124C237.441,189.916,237.175,189.516,237.086,189.725Z'
          transform='translate(-233.276 -183.455)'
          fill={color}
        />
        <path
          id='Path_2040'
          data-name='Path 2040'
          d='M246.479,182.469c-.253-.051-.088.275-.088.275C246.346,182.908,246.731,182.52,246.479,182.469Z'
          transform='translate(-242.24 -176.491)'
          fill={color}
        />
        <path
          id='Path_2041'
          data-name='Path 2041'
          d='M274.916,173.035c.084-.231-.247-.122-.247-.122C274.521,172.847,274.832,173.266,274.916,173.035Z'
          transform='translate(-269.605 -167.228)'
          fill={color}
        />
        <path
          id='Path_2042'
          data-name='Path 2042'
          d='M264.6,178.247c.245.021.054-.27.054-.27C264.673,177.816,264.35,178.226,264.6,178.247Z'
          transform='translate(-259.81 -172.115)'
          fill={color}
        />
        <path
          id='Path_2043'
          data-name='Path 2043'
          d='M255.758,174.715c.143.2.241-.134.241-.134C256.136,174.495,255.615,174.515,255.758,174.715Z'
          transform='translate(-251.328 -168.82)'
          fill={color}
        />
        <circle
          id='Ellipse_71'
          data-name='Ellipse 71'
          cx='0.135'
          cy='0.135'
          r='0.135'
          transform='translate(2.892 6.148)'
          fill={color}
        />
        <path
          id='Path_2044'
          data-name='Path 2044'
          d='M218.467,182.406c-.128-.187-.224.119-.224.119C218.114,182.6,218.595,182.592,218.467,182.406Z'
          transform='translate(-215.043 -176.377)'
          fill={color}
        />
        <path
          id='Path_2045'
          data-name='Path 2045'
          d='M219.072,192.782c-.148-.065.163.354.247.123S219.072,192.782,219.072,192.782Z'
          transform='translate(-215.828 -186.447)'
          fill={color}
        />
        <path
          id='Path_2046'
          data-name='Path 2046'
          d='M199.506,183.093c-.088.209.221.124.221.124C199.86,183.284,199.594,182.885,199.506,183.093Z'
          transform='translate(-196.925 -177.041)'
          fill={color}
        />
        <path
          id='Path_2047'
          data-name='Path 2047'
          d='M208.891,175.836c-.253-.051-.088.275-.088.275C208.758,176.276,209.143,175.887,208.891,175.836Z'
          transform='translate(-205.882 -170.076)'
          fill={color}
        />
        <path
          id='Path_2048'
          data-name='Path 2048'
          d='M289.843,186.1a.135.135,0,1,1-.135.135A.135.135,0,0,1,289.843,186.1Z'
          transform='translate(-284.19 -180.009)'
          fill={color}
        />
        <path
          id='Path_2049'
          data-name='Path 2049'
          d='M298.459,180.79c-.128.077.352.067.224-.119S298.459,180.79,298.459,180.79Z'
          transform='translate(-292.633 -174.698)'
          fill={color}
        />
        <path
          id='Path_2050'
          data-name='Path 2050'
          d='M279.489,192.851c.143.2.241-.134.241-.134C279.867,192.631,279.346,192.651,279.489,192.851Z'
          transform='translate(-274.281 -186.362)'
          fill={color}
        />
        <path
          id='Path_2051'
          data-name='Path 2051'
          d='M279.72,181.364c-.088.209.221.124.221.124C280.075,181.555,279.808,181.155,279.72,181.364Z'
          transform='translate(-274.514 -175.368)'
          fill={color}
        />
        <path
          id='Path_2052'
          data-name='Path 2052'
          d='M289.113,174.1c-.253-.051-.089.275-.089.275C288.98,174.541,289.366,174.153,289.113,174.1Z'
          transform='translate(-283.478 -168.398)'
          fill={color}
        />
        <path
          id='Path_2053'
          data-name='Path 2053'
          d='M228.78,171.616c.245.021.054-.27.054-.27C228.858,171.185,228.535,171.6,228.78,171.616Z'
          transform='translate(-225.167 -165.701)'
          fill={color}
        />
        <path
          id='Path_2054'
          data-name='Path 2054'
          d='M193.371,173.035c.084-.231-.247-.122-.247-.122C192.976,172.847,193.287,173.266,193.371,173.035Z'
          transform='translate(-190.73 -167.228)'
          fill={color}
        />
        <path
          id='Path_2055'
          data-name='Path 2055'
          d='M183.052,178.247c.245.021.054-.27.054-.27C183.13,177.816,182.807,178.226,183.052,178.247Z'
          transform='translate(-180.936 -172.115)'
          fill={color}
        />
      </g>
    </svg>
  )
}

export const Handbag = ({ color = 'currentColor', width = 8 }) => {
  return (
    <svg
      version='1.1'
      id='Capa_1'
      x='0px'
      y='0px'
      viewBox='0 0 511.999 511.999'
      width={width}
      fill={color}
    >
      <g>
        <g>
          <path
            d='M496.619,428.582l-51.45-221.82h-62.616v48.827H393.1v30.001h-51.096v-30.001h10.547v-48.827H159.448v48.827h10.547
     v30.001H118.9v-30.001h10.547v-48.827H66.83l-51.45,221.82c-4.715,20.332,0.026,41.364,13.011,57.705
     c12.985,16.341,32.401,25.712,53.272,25.712h348.672c20.871,0,40.289-9.372,53.273-25.712
     C496.593,469.946,501.335,448.914,496.619,428.582z M298.917,285.591H271v23.18h-30.001v-23.18h-27.917V255.59h85.836V285.591z'
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d='M255.999,0c-69.781,0-126.553,56.772-126.553,126.552v80.21h30.001v-80.21c0-53.239,43.313-96.551,96.552-96.551
     c53.238,0,96.552,43.313,96.552,96.551v80.21h30.001v-80.21C382.552,56.772,325.781,0,255.999,0z'
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  )
}

// SVG EllipsisIcon icon
export const EllipsisIcon = ({
  color = 'currentColor',
  width = 26,
  height = 6
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 26 6'
    >
      <g id='Group_152' data-name='Group 152' transform='translate(589 479)'>
        <ellipse
          id='Ellipse_20'
          data-name='Ellipse 20'
          cx='3.136'
          cy='3'
          rx='3.136'
          ry='3'
          transform='translate(-589 -479)'
          fill={color}
        />
        <ellipse
          id='Ellipse_22'
          data-name='Ellipse 22'
          cx='3.136'
          cy='3'
          rx='3.136'
          ry='3'
          transform='translate(-569.271 -479)'
          fill={color}
        />
        <ellipse
          id='Ellipse_21'
          data-name='Ellipse 21'
          cx='3.136'
          cy='3'
          rx='3.136'
          ry='3'
          transform='translate(-579.136 -479)'
          fill={color}
        />
      </g>
    </svg>
  )
}

// SVG ArrowNext icon
export const GiftBox = ({
  color = 'currentColor',
  width = 15,
  height = 16
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 15 16'
    >
      <g id='Group_2485' data-name='Group 2485' transform='translate(-81.5 40)'>
        <g id='Group_2484' data-name='Group 2484'>
          <g
            id='Group_2483'
            data-name='Group 2483'
            transform='translate(-5.5 21)'
          >
            <path
              id='_ionicons_svg_ios-gift_1_'
              data-name='_ionicons_svg_ios-gift (1)'
              d='M61.714,35.714H58.7a2.1,2.1,0,0,0,.725-1.571A2.2,2.2,0,0,0,57.175,32a1.993,1.993,0,0,0-1.746.979A1.993,1.993,0,0,0,53.682,32a2.2,2.2,0,0,0-2.254,2.143,2.086,2.086,0,0,0,.725,1.571H49.143A1.142,1.142,0,0,0,48,36.857v.714a.143.143,0,0,0,.143.143H62.714a.143.143,0,0,0,.143-.143v-.714A1.142,1.142,0,0,0,61.714,35.714ZM57.175,33a1.144,1.144,0,1,1,0,2.286h-1.2C55.971,33.571,56.511,33,57.175,33Zm-3.493,0c.664,0,1.2.571,1.2,2.286h-1.2a1.144,1.144,0,1,1,0-2.286Zm-5.111,5.929v7.929A1.146,1.146,0,0,0,49.714,48h5.214V38.643H48.857A.287.287,0,0,0,48.571,38.929ZM62,38.643H55.929V48h5.214a1.146,1.146,0,0,0,1.143-1.143V38.929A.287.287,0,0,0,62,38.643Z'
              transform='translate(39 -93)'
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

// SVG ArrowNext icon
export const ArrowNext = ({ color = 'currentColor', width = 20 }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width={width}>
      <path
        d='M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z'
        fill={color}
        stroke='currentColor'
      />
    </svg>
  )
}

// SVG ArrowPrev icon
export const ArrowPrev = ({ color = 'currentColor', width = 20 }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width={width}>
      <path
        d='M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z'
        fill={color}
        stroke='currentColor'
      />
    </svg>
  )
}

// SVG Lock icon
export const LockIcon = ({ color = 'currentColor', width = 15 }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width={width}>
      <path d='M376 192h-24v-46.7c0-52.7-42-96.5-94.7-97.3-53.4-.7-97.3 42.8-97.3 96v48h-24c-22 0-40 18-40 40v192c0 22 18 40 40 40h240c22 0 40-18 40-40V232c0-22-18-40-40-40zM270 316.8v68.8c0 7.5-5.8 14-13.3 14.4-8 .4-14.7-6-14.7-14v-69.2c-11.5-5.6-19.1-17.8-17.9-31.7 1.4-15.5 14.1-27.9 29.6-29 18.7-1.3 34.3 13.5 34.3 31.9 0 12.7-7.3 23.6-18 28.8zM324 192H188v-48c0-18.1 7.1-35.1 20-48s29.9-20 48-20 35.1 7.1 48 20 20 29.9 20 48v48z' />
    </svg>
  )
}

// SVG SearchIcon icon
export const SearchIcon = ({
  color = 'currentColor',
  width = 17,
  height = 17
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 17.071 17'
    >
      <path
        id='_ionicons_svg_ios-search_5_'
        data-name='_ionicons_svg_ios-search (5)'
        d='M79.812,78.742l-4.45-4.491a6.342,6.342,0,1,0-.962.975l4.421,4.461a.685.685,0,0,0,.967.025A.689.689,0,0,0,79.812,78.742ZM70.379,75.28a5.007,5.007,0,1,1,3.542-1.466A4.977,4.977,0,0,1,70.379,75.28Z'
        transform='translate(-63.5 -63.4)'
        fill={color}
        stroke='currentColor'
        strokeWidth='1'
      />
    </svg>
  )
}

// SVG SearchIcon icon
export const SearchIconSmall = ({
  color = 'currentColor',
  width = 14,
  height = 14
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 14.01 14.01'
    >
      <path
        id='_ionicons_svg_ios-search_5_'
        data-name='_ionicons_svg_ios-search (5)'
        d='M77.845,76.9l-3.9-3.932a5.553,5.553,0,1,0-.843.854l3.871,3.906a.6.6,0,0,0,.846.022A.6.6,0,0,0,77.845,76.9Zm-8.26-3.031a4.384,4.384,0,1,1,3.1-1.284A4.358,4.358,0,0,1,69.586,73.865Z'
        transform='translate(-64 -63.9)'
        fill={color}
      />
    </svg>
  )
}

// SVG SmartPhone icon
export const SmartPhone = ({
  color = 'currentColor',
  width = 16,
  height = 24
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16 24'
    >
      <g id='smartphone' transform='translate(0)'>
        <path
          id='Path_111'
          data-name='Path 111'
          d='M67.566,18.7V.808A.808.808,0,0,0,66.757,0H52.772a.808.808,0,0,0-.808.808V18.7h15.6Zm-7.8-4.449a.848.848,0,1,1,.848-.848A.848.848,0,0,1,59.765,14.247Zm2.844-2.267a.647.647,0,0,1-.914,0,2.728,2.728,0,0,0-3.859,0,.647.647,0,0,1-.915-.914,4.021,4.021,0,0,1,5.688,0A.646.646,0,0,1,62.609,11.98ZM54.991,9.134a6.75,6.75,0,0,1,9.548,0,.647.647,0,1,1-.915.914,5.457,5.457,0,0,0-7.719,0,.647.647,0,0,1-.915-.914Z'
          transform='translate(-51.964)'
          fill={color}
        />
        <path
          id='Path_112'
          data-name='Path 112'
          d='M51.964,247.371v3.2a.808.808,0,0,0,.808.808H66.757a.808.808,0,0,0,.808-.808v-3.2Zm8.5,2.289h-1.4a.647.647,0,1,1,0-1.293h1.4a.647.647,0,1,1,0,1.293Z'
          transform='translate(-51.964 -227.381)'
          fill={color}
        />
      </g>
    </svg>
  )
}

// SVG CloseIcon icon
export const CloseIcon = ({
  color = 'currentColor',
  width = '10px',
  height = '10px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 10.003 10'
    >
      <path
        id='_ionicons_svg_ios-close_5_'
        data-name='_ionicons_svg_ios-close (5)'
        d='M166.686,165.55l3.573-3.573a.837.837,0,0,0-1.184-1.184l-3.573,3.573-3.573-3.573a.837.837,0,1,0-1.184,1.184l3.573,3.573-3.573,3.573a.837.837,0,0,0,1.184,1.184l3.573-3.573,3.573,3.573a.837.837,0,0,0,1.184-1.184Z'
        transform='translate(-160.5 -160.55)'
        fill={color}
      />
    </svg>
  )
}

// SVG CategoryIcon icon
export const CategoryIcon = ({
  color = 'currentColor',
  width = '14px',
  height = '14px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 14 14'
    >
      <path
        id='Path_2029'
        data-name='Path 2029'
        d='M13.563,7.876H8.313a.437.437,0,0,0-.437.437v5.25A.437.437,0,0,0,8.313,14h5.25A.437.437,0,0,0,14,13.564V8.314A.437.437,0,0,0,13.563,7.876Zm0-7.875H8.313a.437.437,0,0,0-.437.437v5.25a.437.437,0,0,0,.437.437h5.25A.437.437,0,0,0,14,5.688V.438A.437.437,0,0,0,13.563,0ZM5.687,0H.437A.438.438,0,0,0,0,.438v5.25a.437.437,0,0,0,.437.437h5.25a.437.437,0,0,0,.437-.437V.438A.438.438,0,0,0,5.687,0Zm0,7.875H.437A.437.437,0,0,0,0,8.314v5.25A.437.437,0,0,0,.437,14h5.25a.437.437,0,0,0,.437-.437V8.314A.437.437,0,0,0,5.687,7.876Z'
        transform='translate(0 -0.001)'
        fill={color}
      />
    </svg>
  )
}

export const ArrowDropDown = ({
  color = 'currentColor',
  width = '10px',
  height = '5px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 10 5'
    >
      <path
        id='Path_2030'
        data-name='Path 2030'
        d='M0,63.75l5,5,5-5Z'
        transform='translate(0 -63.75)'
        fill={color}
      />
    </svg>
  )
}

export const ShoppingBag = ({
  color = 'currentColor',
  width = '13px',
  height = '16px'
}) => {
  return (
    <span>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width}
        height={height}
        viewBox='0 0 12.686 16'
      >
        <g
          id='Group_2704'
          data-name='Group 2704'
          transform='translate(-27.023 -2)'
        >
          <g
            id='Group_17'
            data-name='Group 17'
            transform='translate(27.023 5.156)'
          >
            <g id='Group_16' data-name='Group 16'>
              <path
                id='Path_3'
                data-name='Path 3'
                d='M65.7,111.043l-.714-9A1.125,1.125,0,0,0,63.871,101H62.459V103.1a.469.469,0,1,1-.937,0V101H57.211V103.1a.469.469,0,1,1-.937,0V101H54.862a1.125,1.125,0,0,0-1.117,1.033l-.715,9.006a2.605,2.605,0,0,0,2.6,2.8H63.1a2.605,2.605,0,0,0,2.6-2.806Zm-4.224-4.585-2.424,2.424a.468.468,0,0,1-.663,0l-1.136-1.136a.469.469,0,0,1,.663-.663l.8.8,2.092-2.092a.469.469,0,1,1,.663.663Z'
                transform='translate(-53.023 -101.005)'
                fill={color}
              />
            </g>
          </g>
          <g id='Group_19' data-name='Group 19' transform='translate(30.274 2)'>
            <g id='Group_18' data-name='Group 18'>
              <path
                id='Path_4'
                data-name='Path 4'
                d='M160.132,0a3.1,3.1,0,0,0-3.093,3.093v.063h.937V3.093a2.155,2.155,0,1,1,4.311,0v.063h.937V3.093A3.1,3.1,0,0,0,160.132,0Z'
                transform='translate(-157.039)'
                fill={color}
              />
            </g>
          </g>
        </g>
      </svg>
    </span>
  )
}

export const ShoppingBagLarge = ({
  color = 'currentColor',
  width = '24px',
  height = '30px'
}) => {
  return (
    <span>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width}
        height={height}
        viewBox='0 0 23.786 30'
      >
        <g
          id='shopping-bag_3_'
          data-name='shopping-bag (3)'
          transform='translate(-53.023)'
        >
          <g id='Group_2704' data-name='Group 2704'>
            <g
              id='Group_17'
              data-name='Group 17'
              transform='translate(53.023 5.918)'
            >
              <g id='Group_16' data-name='Group 16'>
                <path
                  id='Path_3'
                  data-name='Path 3'
                  d='M76.8,119.826l-1.34-16.881A2.109,2.109,0,0,0,73.362,101H70.716v3.921a.879.879,0,1,1-1.757,0V101H60.875v3.921a.879.879,0,1,1-1.757,0V101H56.472a2.109,2.109,0,0,0-2.094,1.937l-1.34,16.886a4.885,4.885,0,0,0,4.87,5.259H71.926a4.884,4.884,0,0,0,4.87-5.261Zm-7.92-8.6-4.544,4.544a.878.878,0,0,1-1.243,0l-2.13-2.13A.878.878,0,0,1,62.2,112.4l1.509,1.508,3.923-3.923a.879.879,0,1,1,1.242,1.243Z'
                  transform='translate(-53.023 -101.005)'
                  fill={color}
                />
              </g>
            </g>
            <g id='Group_19' data-name='Group 19' transform='translate(59.118)'>
              <g id='Group_18' data-name='Group 18'>
                <path
                  id='Path_4'
                  data-name='Path 4'
                  d='M162.838,0a5.806,5.806,0,0,0-5.8,5.8v.119H158.8V5.8a4.042,4.042,0,1,1,8.083,0v.119h1.757V5.8A5.806,5.806,0,0,0,162.838,0Z'
                  transform='translate(-157.039)'
                  fill={color}
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
  )
}

export const PencilIcon = ({
  color = 'currentColor',
  width = '7.2px',
  height = '7.2px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 7.2 7.2'
    >
      <path
        id='_ionicons_svg_md-create'
        d='M64,69.7v1.5h1.5l4.42-4.42-1.5-1.5Zm7.08-4.08a.387.387,0,0,0,0-.56l-.94-.94a.387.387,0,0,0-.56,0l-.74.74,1.5,1.5Z'
        transform='translate(-64 -63.999)'
        fill={color}
      />
    </svg>
  )
}

export const LongArrowLeft = ({
  color = 'currentColor',
  width = '12px',
  height = '8px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 12 8.003'
    >
      <path
        id='_ionicons_svg_ios-arrow-round-back_2_'
        data-name='_ionicons_svg_ios-arrow-round-back (2)'
        d='M116.447,160.177a.545.545,0,0,1,0,.767l-2.53,2.538h9.641a.542.542,0,0,1,0,1.084h-9.641l2.534,2.538a.549.549,0,0,1,0,.767.54.54,0,0,1-.763,0l-3.435-3.46a.608.608,0,0,1-.113-.171.517.517,0,0,1-.042-.208.543.543,0,0,1,.154-.379l3.435-3.46A.531.531,0,0,1,116.447,160.177Z'
        transform='translate(-112.1 -160.023)'
        fill={color}
      />
    </svg>
  )
}

export const CheckMark = ({
  color = 'currentColor',
  width = '20px',
  height = '16px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 20.894 16'
    >
      <path
        id='_ionicons_svg_ios-checkmark_3_'
        data-name='_ionicons_svg_ios-checkmark (3)'
        d='M169.184,175.473l-1.708-1.756a.367.367,0,0,0-.272-.116.352.352,0,0,0-.272.116l-11.837,11.925-4.308-4.308a.375.375,0,0,0-.543,0l-1.727,1.727a.387.387,0,0,0,0,.553l5.434,5.434a1.718,1.718,0,0,0,1.135.553,1.8,1.8,0,0,0,1.126-.534h.01l12.973-13.041A.415.415,0,0,0,169.184,175.473Z'
        transform='translate(-148.4 -173.6)'
        fill={color}
      />
    </svg>
  )
}

// SVG SearchIcon icon
export const NotificationIcon = ({
  color = 'currentColor',
  width = '16px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 15.898 18'
    >
      <path
        id='Path_2062'
        data-name='Path 2062'
        d='M3756.814,4042.745c-.321,1.887-1.279,2.844-2.816,2.832-1.495-.011-2.448-.987-2.74-2.8-.834-.14-1.684-.218-2.494-.44a7.131,7.131,0,0,1-1.956-.838,1.354,1.354,0,0,1-.333-2.139,7.716,7.716,0,0,0,1.7-4.647,16.446,16.446,0,0,1,.793-3.939,4.785,4.785,0,0,1,4.625-3.188,8.258,8.258,0,0,1,2.4.256,4.649,4.649,0,0,1,3.432,3.795c.3,1.292.441,2.62.646,3.934a7.247,7.247,0,0,0,.836,2.789,6.2,6.2,0,0,0,.573.74,1.577,1.577,0,0,1-.41,2.6,7.794,7.794,0,0,1-2.977.89C3757.661,4042.654,3757.234,4042.695,3756.814,4042.745Zm3.407-2.482a8.64,8.64,0,0,1-1.888-5.015c-.139-1.1-.309-2.195-.547-3.274a3.019,3.019,0,0,0-2.075-2.482,5.458,5.458,0,0,0-1.612-.264c-2.086.031-3.318.688-3.815,2.928-.259,1.167-.388,2.365-.561,3.55a7.6,7.6,0,0,1-1.781,4.458c-.022.023-.019.071-.026.1C3749.689,4041.453,3758.313,4041.456,3760.221,4040.263Zm-4.717,2.583h-2.94a1.47,1.47,0,1,0,2.94,0Z'
        transform='translate(-3746.087 -4027.577)'
        fill={color}
      />
    </svg>
  )
}

// SVG Notification dot icon
export const AlertDotIcon = ({
  color = 'currentColor',
  width = '10px',
  height = '10px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 10 10'
    >
      <g
        id='Group_2830'
        data-name='Group 2830'
        transform='translate(-1598 -32)'
      >
        <g
          id='Ellipse_73'
          data-name='Ellipse 73'
          transform='translate(1598 32)'
          fill='#ffffff'
          stroke='currentColor'
          strokeWidth='0.3'
        >
          <circle cx='5' cy='5' r='5' stroke='none' />
          <circle cx='5' cy='5' r='4.85' fill='none' />
        </g>
        <path
          id='Path_2700'
          data-name='Path 2700'
          d='M2,0A2,2,0,1,1,0,2,2,2,0,0,1,2,0Z'
          transform='translate(1601 35)'
          fill={color}
        />
      </g>
    </svg>
  )
}

// Dashboard
export const DashboardIcon = ({
  color = 'currentColor',
  width = '15px',
  height = '15px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 15 15'
    >
      <g id='Group_2583' data-name='Group 2583' transform='translate(0 0)'>
        <path
          id='Path_2129'
          data-name='Path 2129'
          d='M1667.731,877.683a3.066,3.066,0,1,1-3.067-3.068A3.061,3.061,0,0,1,1667.731,877.683Z'
          transform='translate(-1652.731 -865.747)'
          fill={color}
        />
        <path
          id='Path_2130'
          data-name='Path 2130'
          d='M1471.213,874.615a3.066,3.066,0,1,1-3.072,3.064A3.06,3.06,0,0,1,1471.213,874.615Z'
          transform='translate(-1468.141 -865.747)'
          fill={color}
        />
        <path
          id='Path_2131'
          data-name='Path 2131'
          d='M1474.272,684.227a3.066,3.066,0,1,1-3.044-3.075A3.063,3.063,0,0,1,1474.272,684.227Z'
          transform='translate(-1468.14 -681.152)'
          fill={color}
        />
        <path
          id='Path_2132'
          data-name='Path 2132'
          d='M1674.436,691.284q0,1.143,0,2.286c0,.335-.107.441-.443.441h-4.572c-.326,0-.438-.108-.438-.43q0-2.295,0-4.589c0-.323.111-.433.435-.433h4.572c.344,0,.445.105.446.455Q1674.436,690.149,1674.436,691.284Z'
          transform='translate(-1659.775 -688.219)'
          fill={color}
        />
      </g>
    </svg>
  )
}

// Product
export const ProductIcon = ({
  color = 'currentColor',
  width = '16px',
  height = '13px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 15.6 13'
    >
      <path
        id='Path_154'
        data-name='Path 154'
        d='M299.593,418.656l-3.148-4.494a.9.9,0,0,0-.572-.272.658.658,0,0,0-.573.272l-3.148,4.494h-3.435a.66.66,0,0,0-.716.677v.207l1.789,6.327a1.448,1.448,0,0,0,1.36,1.023h9.3a1.366,1.366,0,0,0,1.359-1.023l1.789-6.327v-.207a.659.659,0,0,0-.716-.677Zm-5.87,0,2.149-3,2.145,3Zm2.149,5.443a1.362,1.362,0,1,1,1.428-1.363,1.4,1.4,0,0,1-1.428,1.363Zm0,0'
        transform='translate(-288 -413.89)'
        fill={color}
      />
    </svg>
  )
}

// Category
export const SidebarCategoryIcon = ({
  color = 'currentColor',
  width = '13px',
  height = '13px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 12.958 13'
    >
      <path
        id='Path_321'
        data-name='Path 321'
        d='M1.015,10.3,1,4.388a.4.4,0,0,1,.564-.373l5.379,2.3a.4.4,0,0,1,.246.371L7.2,12.594a.4.4,0,0,1-.564.373l-5.379-2.3A.4.4,0,0,1,1.015,10.3Zm12.323-5.63L8.375,6.816l.013,5.468,4.963-2.15-.013-5.468m.2-.713a.405.405,0,0,1,.405.4l.014,5.908a.4.4,0,0,1-.244.372L8.347,12.963a.4.4,0,0,1-.565-.37L7.768,6.684a.4.4,0,0,1,.244-.372l5.368-2.325a.4.4,0,0,1,.16-.034ZM7.44.626l-5.149,2.3L7.451,5.2,12.6,2.9,7.44.626m0-.626A.4.4,0,0,1,7.6.034l5.659,2.495a.4.4,0,0,1,0,.74L7.617,5.79a.4.4,0,0,1-.328,0L1.63,3.3a.4.4,0,0,1,0-.74L7.275.035A.4.4,0,0,1,7.439,0Z'
        transform='translate(-1.001)'
        fill={color}
      />
    </svg>
  )
}

// Orders
export const OrderIcon = ({
  color = 'currentColor',
  width = '11px',
  height = '13px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 11.321 13'
    >
      <g id='Group_1087' data-name='Group 1087' transform='translate(0)'>
        <g id='Group_1086' data-name='Group 1086'>
          <path
            id='Path_322'
            data-name='Path 322'
            d='M274.867.365A.733.733,0,0,0,274.234,0h-2.718V3.215h5Z'
            transform='translate(-265.461)'
            fill={color}
          />
          <path
            id='Path_323'
            data-name='Path 323'
            d='M48.821,0H46.077a.733.733,0,0,0-.633.366L43.8,3.215h5.02V0Z'
            transform='translate(-43.528)'
            fill={color}
          />
          <path
            id='Path_324'
            data-name='Path 324'
            d='M33.057,156.648v8.127a.9.9,0,0,0,.9.9h9.529a.9.9,0,0,0,.9-.9v-8.127Zm7.39,3.418-1.971,1.971a.38.38,0,0,1-.539,0l-.924-.924a.381.381,0,1,1,.539-.539l.654.654,1.7-1.7a.381.381,0,1,1,.539.539Z'
            transform='translate(-33.057 -152.671)'
            fill={color}
          />
        </g>
      </g>
    </svg>
  )
}

// Customers
export const CustomerIcon = ({
  color = 'currentColor',
  width = '12.5px',
  height = '13px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 12.489 13'
    >
      <g id='group_1_' data-name='group (1)' transform='translate(0)'>
        <path
          id='Path_327'
          data-name='Path 327'
          d='M43.356,2.708a.328.328,0,0,0,.459-.062,5.053,5.053,0,0,1,8.04,0,.328.328,0,1,0,.521-.4,5.708,5.708,0,0,0-9.081,0A.328.328,0,0,0,43.356,2.708Z'
          transform='translate(-41.591)'
          fill={color}
        />
        <path
          id='Path_328'
          data-name='Path 328'
          d='M228.037,79.44a1.023,1.023,0,1,0,1.023-1.023A1.024,1.024,0,0,0,228.037,79.44Z'
          transform='translate(-218.311 -74.985)'
          fill={color}
        />
        <path
          id='Path_329'
          data-name='Path 329'
          d='M214.438,130.872l-.26-.08a.306.306,0,0,0-.273.048l-.514.385-.514-.385a.306.306,0,0,0-.273-.048l-.26.08a1.013,1.013,0,0,0-.693.962v1.546a.3.3,0,0,0,.05.168l.519.789v2.073a.306.306,0,0,0,.306.306h1.731a.306.306,0,0,0,.306-.306v-2.073l.519-.789a.305.305,0,0,0,.05-.168v-1.546A1.013,1.013,0,0,0,214.438,130.872Z'
          transform='translate(-202.642 -125.054)'
          fill={color}
        />
        <path
          id='Path_330'
          data-name='Path 330'
          d='M23.247,80.463a1.023,1.023,0,1,0-1.023-1.023A1.024,1.024,0,0,0,23.247,80.463Z'
          transform='translate(-21.507 -74.985)'
          fill={color}
        />
        <path
          id='Path_331'
          data-name='Path 331'
          d='M8.626,130.872l-.26-.08a.306.306,0,0,0-.273.048l-.514.385-.514-.385a.306.306,0,0,0-.273-.048l-.26.08a1.013,1.013,0,0,0-.693.962v1.546a.3.3,0,0,0,.05.168l.519.789v2.073a.306.306,0,0,0,.306.306H8.445a.306.306,0,0,0,.306-.306v-2.073l.519-.789a.305.305,0,0,0,.05-.168v-1.546A1.013,1.013,0,0,0,8.626,130.872Z'
          transform='translate(-5.839 -125.054)'
          fill={color}
        />
        <path
          id='Path_332'
          data-name='Path 332'
          d='M121,40.028a1.319,1.319,0,1,0-1.319,1.319A1.321,1.321,0,0,0,121,40.028Z'
          transform='translate(-113.433 -37.015)'
          fill={color}
        />
        <path
          id='Path_333'
          data-name='Path 333'
          d='M100.82,110.947h0l-.377-.116a.117.117,0,0,0-.144.072l-.792,2.173a.143.143,0,0,1-.269,0l-.792-2.173a.117.117,0,0,0-.11-.077c-.011,0-.411.121-.411.121a1.169,1.169,0,0,0-.8,1.11v2.3a.117.117,0,0,0,.019.064l.826,1.257v3.181a.117.117,0,0,0,.117.117h2.573a.117.117,0,0,0,.117-.117v-3.181l.826-1.257a.117.117,0,0,0,.019-.064v-2.3A1.161,1.161,0,0,0,100.82,110.947Z'
          transform='translate(-93.126 -105.975)'
          fill={color}
        />
        <path
          id='Path_334'
          data-name='Path 334'
          d='M141.079,111.386a.174.174,0,0,0-.129-.054h-.361a.174.174,0,0,0-.129.054.167.167,0,0,0-.022.2l.193.291-.09.762.178.473a.054.054,0,0,0,.1,0l.178-.473-.09-.762.193-.291A.167.167,0,0,0,141.079,111.386Z'
          transform='translate(-134.525 -106.459)'
          fill={color}
        />
      </g>
    </svg>
  )
}

// Inbox
export const InboxIcon = ({
  color = 'currentColor',
  width = '14px',
  height = '12px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 13.867 12.133'
    >
      <g id='Group_2932' data-name='Group 2932' transform='translate(0 0)'>
        <path
          id='Path_325'
          data-name='Path 325'
          d='M7,3V0H5V3H4L6,5.5,8,3Z'
          transform='translate(1 4)'
          fill={color}
        />
        <path
          id='Path_326'
          data-name='Path 326'
          d='M11.267,1H9.533v.867H10.66L12.913,8.8H9.533v1.733h-5.2V8.8H.953L3.207,1.867H4.333V1H2.6L0,8.8v4.333H13.867V8.8Z'
          transform='translate(0 -1)'
          fill={color}
        />
      </g>
    </svg>
  )
}

// Refund
export const RefundIcon = ({
  color = 'currentColor',
  width = '15px',
  height = '13px'
}) => {
  return (
    <svg
      id='Group_2392'
      data-name='Group 2392'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 15 13'
    >
      <g id='Group_2391' data-name='Group 2391'>
        <path
          id='Path_335'
          data-name='Path 335'
          d='M301.479,70.5a3.284,3.284,0,1,0-2.812-3.25A3.058,3.058,0,0,0,301.479,70.5Zm-.765-4.656.625-.361a.275.275,0,0,1,.3.016.377.377,0,0,1,.148.307v2.889a.316.316,0,1,1-.625,0v-2.3l-.173.1a.3.3,0,0,1-.419-.162A.389.389,0,0,1,300.715,65.844Z'
          transform='translate(-289.917 -64)'
          fill={color}
        />
        <path
          id='Path_336'
          data-name='Path 336'
          d='M2.919,213.931l-2.545-.588a.284.284,0,0,0-.259.075A.387.387,0,0,0,0,213.7v5.778a.339.339,0,0,0,.313.361H2.271a1,1,0,0,0,.928-.93l.464-3.759A1.08,1.08,0,0,0,2.919,213.931Z'
          transform='translate(0 -208.28)'
          fill={color}
        />
        <path
          id='Path_337'
          data-name='Path 337'
          d='M138.085,247.5a7.23,7.23,0,0,0-1.64.332.362.362,0,0,0-.235.368c0,.007,0,.014,0,.022a1.747,1.747,0,0,1-.585,1.351,2.141,2.141,0,0,1-1.477.462,11.623,11.623,0,0,1-3.5-.769.38.38,0,0,1-.236-.418.315.315,0,0,1,.4-.281,11.347,11.347,0,0,0,3.339.745,1.552,1.552,0,0,0,1.1-.319.984.984,0,0,0,.334-.772,1.416,1.416,0,0,0-.016-.172c-.118-1-1.254-1.353-2.422-1.627a4.926,4.926,0,0,1-1.335-.569,3.055,3.055,0,0,0-1.539-.521,5.015,5.015,0,0,0-.752.06.353.353,0,0,0-.27.386,1.994,1.994,0,0,1-.009.384l-.464,3.76a.985.985,0,0,1-.02.1l-.017.072a.38.38,0,0,0,.176.416,13.78,13.78,0,0,0,4.481,1.685c1.212,0,3.708-1.418,5.359-2.356.426-.242.779-.443,1.01-.56a.364.364,0,0,0,.193-.321C139.968,248.1,139.195,247.5,138.085,247.5Z'
          transform='translate(-124.96 -239.191)'
          fill={color}
        />
      </g>
    </svg>
  )
}

// Coupons
export const CouponIcon = ({
  color = 'currentColor',
  width = '11px',
  height = '13px'
}) => {
  return (
    <svg
      id='Group_2930'
      data-name='Group 2930'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 11.426 13'
    >
      <g id='voucher'>
        <path
          id='Path_3616'
          data-name='Path 3616'
          d='M116.344,226.9a1.513,1.513,0,0,0-.27.027l-.982-1.113,1.958-2.219a1.526,1.526,0,0,0-.135-2.15l-2.839,3.218,0,0-.632.716h-.769l.386.439-.984,1.115a1.523,1.523,0,1,0,1.222,1.493,1.5,1.5,0,0,0-.085-.478l.862-.977.839.952a1.5,1.5,0,0,0-.093.5,1.523,1.523,0,1,0,1.523-1.523Zm-4.57,2.285a.762.762,0,1,1,.762-.762A.764.764,0,0,1,111.774,229.182Zm4.57,0a.762.762,0,1,1,.762-.762A.764.764,0,0,1,116.344,229.182Zm0,0'
          transform='translate(-107.965 -216.944)'
          fill={color}
        />
        <path
          id='Path_3617'
          data-name='Path 3617'
          d='M4.605,0V1.574H3.844V0H-2.25V7.668H2.884l.96-1.089v-1.2h.762v.335L6.632,3.425l.571.5A2.287,2.287,0,0,1,7.409,7.15l-.457.518H9.176V0ZM1.178,3.479A1.141,1.141,0,0,1,1.559,5.7v.8H.8V5.7A1.139,1.139,0,0,1,.035,4.621H.8a.381.381,0,1,0,.381-.381A1.141,1.141,0,0,1,.8,2.024v-.83h.762v.83A1.139,1.139,0,0,1,2.32,3.1H1.559a.381.381,0,1,0-.381.381ZM4.605,4.621H3.844V3.859h.762Zm0-1.523H3.844V2.336h.762Zm0,0'
          transform='translate(2.25)'
          fill={color}
        />
      </g>
    </svg>
  )
}

// Settings
export const SettingIcon = ({
  color = 'currentColor',
  width = '13px',
  height = '13px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 13 13'
    >
      <path
        id='_005-repairing-service'
        data-name='005-repairing-service'
        d='M12.961,5.778a.423.423,0,0,0-.418-.32,1.435,1.435,0,0,1-.982-2.5.361.361,0,0,0,.04-.49,6.435,6.435,0,0,0-1.03-1.04.362.362,0,0,0-.494.04,1.5,1.5,0,0,1-1.621.364A1.444,1.444,0,0,1,7.577.422a.361.361,0,0,0-.319-.38A6.487,6.487,0,0,0,5.8.039a.362.362,0,0,0-.322.372A1.446,1.446,0,0,1,4.584,1.8a1.5,1.5,0,0,1-1.609-.367.362.362,0,0,0-.491-.041,6.462,6.462,0,0,0-1.051,1.04.362.362,0,0,0,.039.494,1.44,1.44,0,0,1,.363,1.622,1.5,1.5,0,0,1-1.414.879.354.354,0,0,0-.376.319,6.516,6.516,0,0,0,0,1.478.43.43,0,0,0,.426.32,1.426,1.426,0,0,1,1.338.891,1.446,1.446,0,0,1-.364,1.607.361.361,0,0,0-.039.49,6.458,6.458,0,0,0,1.028,1.04.361.361,0,0,0,.495-.039,1.5,1.5,0,0,1,1.62-.364,1.442,1.442,0,0,1,.88,1.411.361.361,0,0,0,.319.38,6.472,6.472,0,0,0,1.462,0,.362.362,0,0,0,.322-.372,1.445,1.445,0,0,1,.89-1.386,1.5,1.5,0,0,1,1.61.366.363.363,0,0,0,.491.041,6.47,6.47,0,0,0,1.051-1.04.361.361,0,0,0-.039-.494,1.44,1.44,0,0,1-.364-1.621,1.455,1.455,0,0,1,1.33-.881l.08,0a.362.362,0,0,0,.38-.319A6.487,6.487,0,0,0,12.961,5.778ZM6.5,10.247A3.747,3.747,0,1,1,9.719,8.421L8.078,6.78A2.3,2.3,0,0,0,5.356,3.666a.26.26,0,0,0-.18.181.254.254,0,0,0,.072.248s.81.816,1.081,1.087a.168.168,0,0,1,.024.121l0,.018a5.181,5.181,0,0,1-.123.793l-.017.017-.018.018a5.107,5.107,0,0,1-.805.125v0l-.014,0H5.361a.173.173,0,0,1-.125-.053c-.282-.282-1.06-1.055-1.06-1.055a.265.265,0,0,0-.189-.084.257.257,0,0,0-.242.2A2.3,2.3,0,0,0,6.859,8L8.518,9.657A3.728,3.728,0,0,1,6.5,10.247Z'
        transform='translate(-0.002 0.001)'
        fill={color}
      />
    </svg>
  )
}

// Logout
export const LogoutIcon = ({
  color = 'currentColor',
  width = '16px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 15.999 13'
    >
      <defs>
        <filter
          id='Path_319'
          x='4.583'
          y='1.792'
          width='11.416'
          height='10.333'
          filterUnits='userSpaceOnUse'
        >
          {/* <feOffset dy="1" input="SourceAlpha" /> */}
          <feGaussianBlur stdDeviation='1' result='blur' />
          <feFlood floodOpacity='0.161' />
          <feComposite operator='in' in2='blur' />
          <feComposite in='SourceGraphic' />
        </filter>
      </defs>
      <g id='_007-logout' data-name='007-logout' transform='translate(0)'>
        <g id='Group_1075' data-name='Group 1075'>
          <g id='Group_1074' data-name='Group 1074' transform='translate(0)'>
            <g transform='matrix(1, 0, 0, 1, 0, 0)' filter='url(#Path_319)'>
              <path
                id='Path_319-2'
                data-name='Path 319'
                d='M304.055,151.3a.547.547,0,0,0-.118-.177l-1.624-1.624a.542.542,0,0,0-.766.766l.7.7h-3.026a.542.542,0,1,0,0,1.083h3.026l-.7.7a.542.542,0,1,0,.766.766l1.624-1.624a.536.536,0,0,0,.118-.177A.542.542,0,0,0,304.055,151.3Z'
                transform='translate(-291.1 -145.55)'
                fill={color}
              />
            </g>
            <path
              id='Path_320'
              data-name='Path 320'
              d='M9.222,7.583a.542.542,0,0,0-.542.542v2.708H6.514V2.167a.542.542,0,0,0-.386-.519L4.247,1.083H8.681V3.792a.542.542,0,0,0,1.083,0V.542A.542.542,0,0,0,9.222,0H.556A.483.483,0,0,0,.5.01.535.535,0,0,0,.27.09C.258.1.244.1.232.107S.226.116.222.12A.537.537,0,0,0,.078.291.442.442,0,0,0,.063.336.514.514,0,0,0,.02.463a.337.337,0,0,0,0,.047C.021.521.014.531.014.542V11.375a.541.541,0,0,0,.435.531l5.417,1.083A.5.5,0,0,0,5.972,13a.542.542,0,0,0,.542-.542v-.542H9.222a.542.542,0,0,0,.542-.542V8.125A.542.542,0,0,0,9.222,7.583Z'
              transform='translate(-0.014)'
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export const CarretDownIcon = ({
  color = 'currentColor',
  width = '10px',
  height = '5px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 10 5'
    >
      <path
        id='_ionicons_svg_md-arrow-dropdown_2_'
        data-name='_ionicons_svg_md-arrow-dropdown (2)'
        d='M128,192l5,5,5-5Z'
        transform='translate(-128 -192)'
        fill={color}
      />
    </svg>
  )
}

export const CarretUpIcon = ({
  color = 'currentColor',
  width = '10px',
  height = '5px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 10 5'
    >
      <path
        id='_ionicons_svg_md-arrow-dropdown_2_'
        data-name='_ionicons_svg_md-arrow-dropdown (2)'
        d='M128,192l5,5,5-5Z'
        transform='translate(138 197) rotate(180)'
        fill={color}
      />
    </svg>
  )
}

export const OptionIcon = ({
  color = 'currentColor',
  width = '3.5px',
  height = '14px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 3.5 14'
    >
      <path
        id='_ionicons_svg_md-more_1_'
        data-name='_ionicons_svg_md-more (1)'
        d='M219.5,97.75a1.75,1.75,0,1,0-1.75,1.75A1.755,1.755,0,0,0,219.5,97.75Zm0,10.5a1.75,1.75,0,1,0-1.75,1.75A1.755,1.755,0,0,0,219.5,108.25Zm0-5.25a1.75,1.75,0,1,0-1.75,1.75A1.755,1.755,0,0,0,219.5,103Z'
        transform='translate(-216 -96)'
        fill={color}
      />
    </svg>
  )
}

export const Revenue = ({
  color = 'currentColor',
  width = '56px',
  height = '56px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 56 56'
    >
      <g
        id='Group_2541'
        data-name='Group 2541'
        transform='translate(-1719 -150)'
      >
        <path
          id='Path_2087'
          data-name='Path 2087'
          d='M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z'
          transform='translate(1719 150)'
          fill='#00c58d'
          opacity='0.2'
        />
        <g
          id='Group_2542'
          data-name='Group 2542'
          transform='translate(1734.867 165.867)'
        >
          <path
            id='Path_2088'
            data-name='Path 2088'
            d='M3854.718,4669.131a.507.507,0,0,0-.359-.15l-.048,0-8.585.831a.511.511,0,0,0-.31.864l1.58,1.58-12.093,12.093a.507.507,0,0,0,0,.718l3.877,3.877a.511.511,0,0,0,.718,0l2.112-2.111a.508.508,0,0,0,.148-.359.507.507,0,0,0-.867-.358l-1.753,1.752-3.159-3.159,12.093-12.094a.506.506,0,0,0,0-.717l-1.177-1.178,6.9-.668-.667,6.9-1.178-1.177a.506.506,0,0,0-.718,0l-9.166,9.165a.508.508,0,1,0,.719.718l8.806-8.806,1.579,1.579a.5.5,0,0,0,.353.146h0a.507.507,0,0,0,.512-.455l.831-8.585A.5.5,0,0,0,3854.718,4669.131Z'
            transform='translate(-3830.598 -4668.98)'
            fill='#00c58d'
          />
          <path
            id='Path_2089'
            data-name='Path 2089'
            d='M3806.064,5023.59a.51.51,0,0,0-.718,0,.509.509,0,0,0,0,.72l3.877,3.876a.5.5,0,0,0,.359.147h0a.5.5,0,0,0,.386-.177.509.509,0,0,0-.026-.688Z'
            transform='translate(-3802.428 -5006.836)'
            fill='#00c58d'
          />
          <path
            id='Path_2090'
            data-name='Path 2090'
            d='M3776.51,5053.146a.508.508,0,0,0-.867.36.5.5,0,0,0,.149.358l3.877,3.877a.5.5,0,0,0,.358.147h0a.506.506,0,0,0,.359-.865Z'
            transform='translate(-3774.258 -5035.007)'
            fill='#00c58d'
          />
          <path
            id='Path_2091'
            data-name='Path 2091'
            d='M3746.954,5082.7a.508.508,0,1,0-.718.718l3.876,3.876a.5.5,0,0,0,.358.147h0a.506.506,0,0,0,.36-.865Z'
            transform='translate(-3746.086 -5063.178)'
            fill='#00c58d'
          />
          <path
            id='Path_2092'
            data-name='Path 2092'
            d='M4054.57,4973.039a4.424,4.424,0,1,0,4.424,4.424A4.43,4.43,0,0,0,4054.57,4973.039Zm0,7.833a3.409,3.409,0,1,1,3.408-3.409A3.413,3.413,0,0,1,4054.57,4980.873Z'
            transform='translate(-4035.901 -4958.794)'
            fill='#00c58d'
          />
          <path
            id='Path_2093'
            data-name='Path 2093'
            d='M4114.442,5005.083a.522.522,0,0,0,.108.011.508.508,0,0,0,.507-.507v-.255a1.265,1.265,0,0,0-1.017-1.246v-.282a.508.508,0,0,0-1.016,0v.309a1.4,1.4,0,0,0,.38,2.745h.255a.383.383,0,0,1,0,.767h-.382a.257.257,0,0,1-.256-.256.508.508,0,0,0-1.015,0,1.267,1.267,0,0,0,1.018,1.246v.281a.508.508,0,1,0,1.016,0v-.308a1.4,1.4,0,0,0,.4-2.5Zm-.251-.137,0,0a1.388,1.388,0,0,0-.535-.106h-.255a.383.383,0,0,1,0-.767h.381a.256.256,0,0,1,.256.256v.255A.5.5,0,0,0,4114.19,5004.945Z'
            transform='translate(-4094.863 -4986.681)'
            fill='#00c58d'
          />
          <path
            id='Path_2094'
            data-name='Path 2094'
            d='M3770.35,4697.666a4.424,4.424,0,1,0-4.424-4.424A4.428,4.428,0,0,0,3770.35,4697.666Zm0-7.832a3.409,3.409,0,1,1-3.408,3.408A3.412,3.412,0,0,1,3770.35,4689.834Z'
            transform='translate(-3764.996 -4687.888)'
            fill='#00c58d'
          />
          <path
            id='Path_2095'
            data-name='Path 2095'
            d='M3829.184,4721.638h.255a.383.383,0,0,1,0,.767h-.382a.256.256,0,0,1-.256-.256.508.508,0,0,0-1.015,0,1.267,1.267,0,0,0,1.018,1.246v.282a.508.508,0,0,0,1.015,0v-.309a1.4,1.4,0,0,0,.4-2.5.474.474,0,0,0,.108.011.508.508,0,0,0,.508-.508v-.254a1.266,1.266,0,0,0-1.018-1.246v-.282a.508.508,0,0,0-1.016,0v.309a1.4,1.4,0,0,0,.381,2.745Zm.791-.909a1.391,1.391,0,0,0-.536-.107h-.255a.383.383,0,1,1,0-.766h.382a.256.256,0,0,1,.256.256v.254A.5.5,0,0,0,3829.975,4720.729Z'
            transform='translate(-3823.958 -4715.777)'
            fill='#00c58d'
          />
        </g>
      </g>
    </svg>
  )
}

export const Refund = ({
  color = 'currentColor',
  width = '56px',
  height = '56px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 56 56'
    >
      <g
        id='Group_2541'
        data-name='Group 2541'
        transform='translate(-1719 -150)'
      >
        <path
          id='Path_2087'
          data-name='Path 2087'
          d='M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z'
          transform='translate(1719 150)'
          fill='#2170ff'
          opacity='0.2'
        />
        <g
          id='Group_2543'
          data-name='Group 2543'
          transform='translate(1733 164)'
        >
          <g
            id='Group_2544'
            data-name='Group 2544'
            transform='translate(4.304 4.304)'
          >
            <g
              id='Group_2543-2'
              data-name='Group 2543'
              transform='translate(0 0)'
            >
              <path
                id='Path_2096'
                data-name='Path 2096'
                d='M5368.315,4398.011a9.7,9.7,0,1,1,9.7-9.7A9.708,9.708,0,0,1,5368.315,4398.011Zm0-18.171a8.475,8.475,0,1,0,8.476,8.475A8.484,8.484,0,0,0,5368.315,4379.84Z'
                transform='translate(-5358.62 -4378.62)'
                fill='#2170ff'
              />
              <path
                id='Path_2097'
                data-name='Path 2097'
                d='M5371.153,4381.62a9.534,9.534,0,1,0,9.533,9.533A9.545,9.545,0,0,0,5371.153,4381.62Zm0,18.171a8.638,8.638,0,1,1,8.638-8.638A8.647,8.647,0,0,1,5371.153,4399.791Z'
                transform='translate(-5361.456 -4381.458)'
                fill='#2170ff'
              />
            </g>
          </g>
          <g
            id='Group_2546'
            data-name='Group 2546'
            transform='translate(10.041 8.13)'
          >
            <g id='Group_2545' data-name='Group 2545' transform='translate(0)'>
              <path
                id='Path_2098'
                data-name='Path 2098'
                d='M5468.736,4461.133a.611.611,0,0,1-.61-.61v-.375c-1.949-.181-3.348-1.2-3.348-2.465a.611.611,0,0,1,1.222,0c0,.5.847,1.09,2.126,1.239v-3.194c-1.642-.465-3.348-1.128-3.348-2.886,0-1.263,1.4-2.284,3.348-2.465V4450a.61.61,0,1,1,1.22,0v.374c1.949.181,3.348,1.2,3.348,2.465a.61.61,0,0,1-1.22,0c0-.495-.848-1.091-2.127-1.238v3.194c1.643.466,3.348,1.126,3.348,2.886,0,1.263-1.4,2.284-3.348,2.465v.375A.61.61,0,0,1,5468.736,4461.133Zm.61-2.21c1.28-.148,2.127-.744,2.127-1.239,0-.7-.562-1.128-2.127-1.611Zm-1.22-7.318c-1.279.147-2.126.743-2.126,1.238,0,.7.562,1.128,2.126,1.611Z'
                transform='translate(-5464.777 -4449.392)'
                fill='#2170ff'
              />
              <path
                id='Path_2099'
                data-name='Path 2099'
                d='M5472.021,4457.758v-3.5c1.465.118,2.452.8,2.452,1.417a.448.448,0,1,0,.9,0c0-1.214-1.438-2.183-3.348-2.314v-.525a.448.448,0,1,0-.9,0v.525c-1.911.131-3.348,1.1-3.348,2.314,0,1.626,1.545,2.26,3.348,2.763v3.495c-1.465-.118-2.452-.8-2.452-1.416a.448.448,0,1,0-.9,0c0,1.213,1.437,2.183,3.348,2.316v.523a.448.448,0,1,0,.9,0v-.523c1.91-.133,3.348-1.1,3.348-2.316C5475.369,4458.895,5473.824,4458.26,5472.021,4457.758Zm-.9-.249c-1.819-.537-2.452-1.026-2.452-1.83,0-.618.987-1.3,2.452-1.417Zm.9,4.428v-3.246c1.818.538,2.452,1.025,2.452,1.83C5474.474,4461.139,5473.486,4461.82,5472.021,4461.937Z'
                transform='translate(-5467.616 -4452.229)'
                fill='#2170ff'
              />
            </g>
          </g>
          <g
            id='Group_2548'
            data-name='Group 2548'
            transform='translate(2.391 0)'
          >
            <g id='Group_2547' data-name='Group 2547' transform='translate(0)'>
              <path
                id='Path_2100'
                data-name='Path 2100'
                d='M5334.839,4327a.61.61,0,1,1,0-1.221,12.786,12.786,0,1,0-9.167-21.685l.844-.281a.6.6,0,0,1,.194-.031.61.61,0,0,1,.192,1.19l-2.869.956a.626.626,0,0,1-.193.031.61.61,0,0,1-.6-.7l.478-3.348a.613.613,0,0,1,.6-.522.667.667,0,0,1,.087,0,.611.611,0,0,1,.518.691l-.173,1.2A14,14,0,1,1,5334.839,4327Z'
                transform='translate(-5323.23 -4299)'
                fill='#2170ff'
              />
              <path
                id='Path_2101'
                data-name='Path 2101'
                d='M5347.463,4306.052a13.838,13.838,0,0,0-20.106.568l.246-1.718a.449.449,0,0,0-.888-.128l-.478,3.348a.451.451,0,0,0,.443.513.449.449,0,0,0,.144-.025l2.869-.956a.448.448,0,0,0-.284-.851l-1.442.48a12.941,12.941,0,1,1,9.712,21.493.449.449,0,0,0,0,.9,13.838,13.838,0,0,0,9.785-23.623Z'
                transform='translate(-5326.069 -4301.836)'
                fill='#2170ff'
              />
            </g>
          </g>
          <g
            id='Group_2550'
            data-name='Group 2550'
            transform='translate(11.005 26.567)'
          >
            <g
              id='Group_2549'
              data-name='Group 2549'
              transform='translate(0 0)'
            >
              <path
                id='Path_2102'
                data-name='Path 2102'
                d='M5483.667,4791.79a.585.585,0,0,1-.087-.006c-.165-.024-.333-.05-.493-.08a.61.61,0,0,1,.106-1.21.563.563,0,0,1,.108.009c.147.025.3.051.451.072a.61.61,0,0,1-.085,1.215Z'
                transform='translate(-5482.584 -4790.493)'
                fill='#2170ff'
              />
              <path
                id='Path_2103'
                data-name='Path 2103'
                d='M5486.569,4793.572c-.153-.021-.307-.045-.457-.073a.448.448,0,1,0-.159.882c.161.03.325.055.487.078a.373.373,0,0,0,.065.006.449.449,0,0,0,.063-.894Z'
                transform='translate(-5485.422 -4793.329)'
                fill='#2170ff'
              />
            </g>
          </g>
          <g
            id='Group_2552'
            data-name='Group 2552'
            transform='translate(8.34 25.795)'
          >
            <g
              id='Group_2551'
              data-name='Group 2551'
              transform='translate(0 0)'
            >
              <path
                id='Path_2104'
                data-name='Path 2104'
                d='M5434.763,4777.729a.579.579,0,0,1-.19-.032c-.305-.1-.611-.212-.909-.333a.611.611,0,1,1,.459-1.131c.272.11.552.213.83.305a.611.611,0,0,1-.19,1.191Z'
                transform='translate(-5433.283 -4776.188)'
                fill='#2170ff'
              />
              <path
                id='Path_2105'
                data-name='Path 2105'
                d='M5437.738,4779.53c-.281-.092-.565-.2-.84-.308a.448.448,0,1,0-.339.83c.3.12.6.231.9.331a.449.449,0,0,0,.279-.853Z'
                transform='translate(-5436.119 -4779.026)'
                fill='#2170ff'
              />
            </g>
          </g>
          <g
            id='Group_2554'
            data-name='Group 2554'
            transform='translate(0.141 15.345)'
          >
            <g
              id='Group_2553'
              data-name='Group 2553'
              transform='translate(0 0)'
            >
              <path
                id='Path_2106'
                data-name='Path 2106'
                d='M5282.4,4585.042a.614.614,0,0,1-.6-.481c-.069-.312-.126-.634-.174-.952a.613.613,0,0,1,.516-.693.771.771,0,0,1,.089,0,.614.614,0,0,1,.6.521c.042.29.1.583.158.87a.607.607,0,0,1-.082.459.614.614,0,0,1-.384.267A.653.653,0,0,1,5282.4,4585.042Z'
                transform='translate(-5281.624 -4582.911)'
                fill='#2170ff'
              />
              <path
                id='Path_2107'
                data-name='Path 2107'
                d='M5285.676,4587.172c-.062-.29-.116-.586-.16-.88a.448.448,0,0,0-.887.13c.046.314.1.631.17.942a.45.45,0,0,0,.438.354.389.389,0,0,0,.1-.012A.446.446,0,0,0,5285.676,4587.172Z'
                transform='translate(-5284.462 -4585.747)'
                fill='#2170ff'
              />
            </g>
          </g>
          <g
            id='Group_2556'
            data-name='Group 2556'
            transform='translate(0.262 9.839)'
          >
            <g
              id='Group_2555'
              data-name='Group 2555'
              transform='translate(0 0)'
            >
              <path
                id='Path_2108'
                data-name='Path 2108'
                d='M5284.464,4483.11a.72.72,0,0,1-.121-.011.611.611,0,0,1-.478-.719c.063-.316.138-.632.223-.943a.614.614,0,0,1,.589-.45.635.635,0,0,1,.161.023.611.611,0,0,1,.428.751c-.077.282-.146.572-.2.86A.611.611,0,0,1,5284.464,4483.11Z'
                transform='translate(-5283.853 -4480.987)'
                fill='#2170ff'
              />
              <path
                id='Path_2109'
                data-name='Path 2109'
                d='M5287.632,4484a.449.449,0,0,0-.552.314c-.083.306-.156.619-.22.931a.448.448,0,0,0,.352.528.461.461,0,0,0,.087.009.452.452,0,0,0,.441-.36c.059-.292.127-.585.206-.87A.45.45,0,0,0,5287.632,4484Z'
                transform='translate(-5286.689 -4483.826)'
                fill='#2170ff'
              />
            </g>
          </g>
          <g
            id='Group_2558'
            data-name='Group 2558'
            transform='translate(0.829 18.034)'
          >
            <g
              id='Group_2557'
              data-name='Group 2557'
              transform='translate(0 0)'
            >
              <path
                id='Path_2110'
                data-name='Path 2110'
                d='M5295.269,4634.7a.61.61,0,0,1-.557-.358c-.132-.293-.257-.594-.368-.9a.612.612,0,0,1,.36-.785.6.6,0,0,1,.211-.039.613.613,0,0,1,.573.4c.1.275.215.55.335.818a.611.611,0,0,1-.306.807A.592.592,0,0,1,5295.269,4634.7Z'
                transform='translate(-5294.306 -4632.626)'
                fill='#2170ff'
              />
              <path
                id='Path_2111'
                data-name='Path 2111'
                d='M5298.513,4636.747c-.122-.271-.236-.549-.34-.829a.448.448,0,0,0-.84.311c.11.3.233.6.363.886a.45.45,0,0,0,.409.264.469.469,0,0,0,.185-.04A.447.447,0,0,0,5298.513,4636.747Z'
                transform='translate(-5297.143 -4635.463)'
                fill='#2170ff'
              />
            </g>
          </g>
          <g
            id='Group_2560'
            data-name='Group 2560'
            transform='translate(0 12.575)'
          >
            <g id='Group_2559' data-name='Group 2559' transform='translate(0)'>
              <path
                id='Path_2112'
                data-name='Path 2112'
                d='M5279.609,4533.781a.612.612,0,0,1-.611-.606c0-.039,0-.077,0-.116,0-.282.01-.569.027-.85a.608.608,0,0,1,.607-.574h.038a.612.612,0,0,1,.573.646c-.015.258-.023.52-.023.778,0,.035,0,.07,0,.107a.612.612,0,0,1-.606.615h0Z'
                transform='translate(-5278.998 -4531.634)'
                fill='#2170ff'
              />
              <path
                id='Path_2113'
                data-name='Path 2113'
                d='M5282.5,4534.634a.449.449,0,0,0-.475.421c-.016.277-.025.561-.025.84v.117a.448.448,0,0,0,.449.443h0a.45.45,0,0,0,.446-.451v-.108c0-.262.006-.526.022-.787A.447.447,0,0,0,5282.5,4534.634Z'
                transform='translate(-5281.836 -4534.47)'
                fill='#2170ff'
              />
            </g>
          </g>
          <g
            id='Group_2562'
            data-name='Group 2562'
            transform='translate(5.893 24.485)'
          >
            <g
              id='Group_2561'
              data-name='Group 2561'
              transform='translate(0 0)'
            >
              <path
                id='Path_2114'
                data-name='Path 2114'
                d='M5389.413,4753.693a.618.618,0,0,1-.306-.083c-.28-.161-.556-.335-.82-.515a.61.61,0,1,1,.685-1.011c.243.165.5.323.748.47a.612.612,0,0,1,.223.834A.615.615,0,0,1,5389.413,4753.693Z'
                transform='translate(-5388.019 -4751.979)'
                fill='#2170ff'
              />
              <path
                id='Path_2115'
                data-name='Path 2115'
                d='M5392.479,4755.533c-.257-.149-.512-.309-.759-.476a.449.449,0,0,0-.5.743c.264.178.537.348.811.509a.454.454,0,0,0,.225.061.449.449,0,0,0,.226-.836Z'
                transform='translate(-5390.858 -4754.817)'
                fill='#2170ff'
              />
            </g>
          </g>
          <g
            id='Group_2564'
            data-name='Group 2564'
            transform='translate(2.054 20.521)'
          >
            <g
              id='Group_2563'
              data-name='Group 2563'
              transform='translate(0 0)'
            >
              <path
                id='Path_2116'
                data-name='Path 2116'
                d='M5318.141,4680.616a.613.613,0,0,1-.493-.25c-.19-.26-.375-.529-.544-.8a.61.61,0,1,1,1.032-.65c.158.248.324.494.5.731a.611.611,0,0,1-.493.971Z'
                transform='translate(-5317.009 -4678.629)'
                fill='#2170ff'
              />
              <path
                id='Path_2117'
                data-name='Path 2117'
                d='M5321.343,4682.579c-.175-.239-.344-.489-.5-.74a.448.448,0,1,0-.758.479c.169.27.35.535.537.792a.449.449,0,0,0,.724-.53Z'
                transform='translate(-5319.85 -4681.467)'
                fill='#2170ff'
              />
            </g>
          </g>
          <g
            id='Group_2566'
            data-name='Group 2566'
            transform='translate(3.769 22.7)'
          >
            <g
              id='Group_2565'
              data-name='Group 2565'
              transform='translate(0 0)'
            >
              <path
                id='Path_2118'
                data-name='Path 2118'
                d='M5350,4720.845a.609.609,0,0,1-.408-.156c-.238-.216-.473-.442-.7-.673a.61.61,0,0,1,.877-.849c.205.211.419.417.637.614a.61.61,0,0,1-.408,1.064Z'
                transform='translate(-5348.718 -4718.981)'
                fill='#2170ff'
              />
              <path
                id='Path_2119'
                data-name='Path 2119'
                d='M5353.132,4722.74c-.221-.2-.437-.408-.644-.623a.448.448,0,1,0-.644.625c.221.228.453.452.688.664a.443.443,0,0,0,.3.116.449.449,0,0,0,.3-.782Z'
                transform='translate(-5351.555 -4721.819)'
                fill='#2170ff'
              />
            </g>
          </g>
          <g
            id='Group_2568'
            data-name='Group 2568'
            transform='translate(1.091 7.652)'
          >
            <g id='Group_2567' data-name='Group 2567' transform='translate(0)'>
              <path
                id='Path_2120'
                data-name='Path 2120'
                d='M5299.792,4442.2a.61.61,0,0,1-.566-.385.609.609,0,0,1,.005-.466c.067-.153.136-.308.208-.457a.616.616,0,0,1,.552-.348.607.607,0,0,1,.261.058.614.614,0,0,1,.29.814c-.066.136-.128.276-.19.415A.608.608,0,0,1,5299.792,4442.2Z'
                transform='translate(-5299.182 -4440.542)'
                fill='#2170ff'
              />
              <path
                id='Path_2121'
                data-name='Path 2121'
                d='M5303.023,4443.585a.449.449,0,0,0-.6.212c-.07.148-.139.3-.2.45a.449.449,0,0,0,.824.356c.061-.141.125-.282.191-.421A.45.45,0,0,0,5303.023,4443.585Z'
                transform='translate(-5302.022 -4443.379)'
                fill='#2170ff'
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const ArrowUp = ({
  color = 'currentColor',
  width = '12px',
  height = '12px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 11.996 12'
    >
      <path
        id='Path_2462'
        data-name='Path 2462'
        d='M18.276,12.1,12.7,6.524a.424.424,0,0,0-.6,0L6.524,12.1a.424.424,0,0,0,0,.6.424.424,0,0,0,.6,0l4.854-4.854V17.977a.423.423,0,1,0,.847,0V7.846L17.677,12.7a.424.424,0,0,0,.6,0A.434.434,0,0,0,18.276,12.1Z'
        transform='translate(-6.4 -6.4)'
        fill={color}
      />
    </svg>
  )
}

export const ArrowDown = ({
  color = 'currentColor',
  width = '12px',
  height = '12px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 11.996 12'
    >
      <path
        id='Path_2462'
        data-name='Path 2462'
        d='M18.276,12.1,12.7,6.524a.424.424,0,0,0-.6,0L6.524,12.1a.424.424,0,0,0,0,.6.424.424,0,0,0,.6,0l4.854-4.854V17.977a.423.423,0,1,0,.847,0V7.846L17.677,12.7a.424.424,0,0,0,.6,0A.434.434,0,0,0,18.276,12.1Z'
        transform='translate(18.396 18.4) rotate(180)'
        fill={color}
      />
    </svg>
  )
}

export const UploadIcon = ({
  color = 'currentColor',
  width = '41px',
  height = '30px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 40.909 30'
    >
      <g id='cloud-storage-uploading-option' transform='translate(0 -73.091)'>
        <path
          id='Path_2125'
          data-name='Path 2125'
          d='M39.129,89.827A8.064,8.064,0,0,0,34.58,86.94,5.446,5.446,0,0,0,30,78.546a5.207,5.207,0,0,0-3.537,1.321,10.921,10.921,0,0,0-10.1-6.776,10.511,10.511,0,0,0-7.713,3.2A10.508,10.508,0,0,0,5.454,84q0,.277.043.916A9.528,9.528,0,0,0,0,93.546a9.193,9.193,0,0,0,2.8,6.743,9.191,9.191,0,0,0,6.744,2.8H32.728a8.172,8.172,0,0,0,6.4-13.264Zm-12.06-.575a.656.656,0,0,1-.479.2H21.818v7.5a.691.691,0,0,1-.681.681H17.045a.691.691,0,0,1-.682-.681v-7.5H11.59a.655.655,0,0,1-.681-.681.8.8,0,0,1,.213-.512L18.6,80.783a.722.722,0,0,1,.98,0l7.5,7.5a.663.663,0,0,1,.191.49A.656.656,0,0,1,27.07,89.252Z'
          transform='translate(0)'
          fill='#e6e6e6'
        />
      </g>
    </svg>
  )
}

export const SiteSettings = ({
  color = 'currentColor',
  width = '56px',
  height = '56px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 56 56'
    >
      <g id='development' transform='translate(-0.001)'>
        <g id='Group_2845' data-name='Group 2845' transform='translate(0.001)'>
          <g id='Group_2844' data-name='Group 2844'>
            <path
              id='Path_2442'
              data-name='Path 2442'
              d='M20.211,11.444l-1.1-.95v-.456l1.1-.95a.935.935,0,0,0,.3-.9,10.074,10.074,0,0,0-.727-2.166.933.933,0,0,0-.762-.537l-1.438-.131q-.146-.211-.3-.41l.31-1.355a.935.935,0,0,0-.287-.9,10.539,10.539,0,0,0-1.877-1.344.934.934,0,0,0-.924.007l-1.237.718c-.167-.057-.338-.111-.516-.16L12.183.567A.934.934,0,0,0,11.324,0H9.212a.933.933,0,0,0-.859.567L7.782,1.909c-.178.049-.349.1-.516.16L6.029,1.351A.938.938,0,0,0,5.1,1.343,10.575,10.575,0,0,0,3.228,2.687a.933.933,0,0,0-.287.9l.31,1.354c-.1.133-.206.271-.3.411L1.51,5.488a.933.933,0,0,0-.762.537A10.066,10.066,0,0,0,.021,8.191a.934.934,0,0,0,.3.9l1.1.95v.456l-1.1.95a.935.935,0,0,0-.3.9,10.074,10.074,0,0,0,.727,2.166.933.933,0,0,0,.762.537l1.438.131q.146.211.3.41l-.31,1.355a.933.933,0,0,0,.287.9A10.455,10.455,0,0,0,5.1,19.189a.931.931,0,0,0,.923-.007l1.238-.717c.167.057.338.111.516.16l.571,1.342a.934.934,0,0,0,.859.567h2.113a.933.933,0,0,0,.859-.567l.571-1.342c.178-.049.349-.1.516-.16l1.237.718a.936.936,0,0,0,1.012-.048l1.71-1.224a.934.934,0,0,0,.366-.968l-.31-1.354c.1-.133.206-.271.3-.411l1.438-.131a.933.933,0,0,0,.762-.537,10.072,10.072,0,0,0,.727-2.166A.935.935,0,0,0,20.211,11.444Zm-2.646.185.994.855q-.107.376-.256.753l-1.333.121a.935.935,0,0,0-.709.439,6.84,6.84,0,0,1-.688.931.933.933,0,0,0-.21.827l.274,1.2-.714.511-1.1-.638A.939.939,0,0,0,13,16.572a6.962,6.962,0,0,1-1.127.352.933.933,0,0,0-.651.544l-.511,1.2h-.88l-.511-1.2a.929.929,0,0,0-.651-.544,6.989,6.989,0,0,1-1.127-.352.932.932,0,0,0-.826.055l-1.146.664q-.349-.224-.68-.486l.286-1.25a.934.934,0,0,0-.209-.826,6.863,6.863,0,0,1-.689-.931.935.935,0,0,0-.709-.439l-1.333-.121q-.148-.377-.256-.753l.994-.855a.935.935,0,0,0,.324-.707V9.611A.935.935,0,0,0,2.971,8.9l-.994-.856q.107-.375.256-.752l1.332-.121a.935.935,0,0,0,.709-.439A6.839,6.839,0,0,1,4.963,5.8a.933.933,0,0,0,.21-.827l-.286-1.25q.33-.261.681-.487l1.145.664a.942.942,0,0,0,.826.055,6.962,6.962,0,0,1,1.127-.352.933.933,0,0,0,.651-.544l.511-1.2h.88l.511,1.2a.929.929,0,0,0,.651.544A6.977,6.977,0,0,1,13,3.961a.936.936,0,0,0,.826-.055l1.145-.664q.35.226.681.487l-.286,1.25a.934.934,0,0,0,.209.826,6.864,6.864,0,0,1,.689.931.935.935,0,0,0,.709.439L18.3,7.3q.148.377.256.753l-.994.855a.935.935,0,0,0-.324.707v1.311A.935.935,0,0,0,17.565,11.629Z'
              transform='translate(-0.001)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2847'
          data-name='Group 2847'
          transform='translate(5.601 5.6)'
        >
          <g id='Group_2846' data-name='Group 2846'>
            <path
              id='Path_2443'
              data-name='Path 2443'
              d='M52.669,48a4.667,4.667,0,1,0,4.667,4.667A4.667,4.667,0,0,0,52.669,48Zm0,7.467a2.8,2.8,0,1,1,2.8-2.8A2.8,2.8,0,0,1,52.669,55.467Z'
              transform='translate(-48.002 -48)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2849'
          data-name='Group 2849'
          transform='translate(1.868 46.667)'
        >
          <g id='Group_2848' data-name='Group 2848'>
            <path
              id='Path_2444'
              data-name='Path 2444'
              d='M24.4,400H16.935a.933.933,0,0,0-.933.933h0V408.4a.933.933,0,0,0,.933.933H24.4a.933.933,0,0,0,.933-.933h0v-7.467A.933.933,0,0,0,24.4,400Zm-.934,7.467h-5.6v-5.6h5.6Z'
              transform='translate(-16.002 -400)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2851'
          data-name='Group 2851'
          transform='translate(15.868 43.867)'
        >
          <g id='Group_2850' data-name='Group 2850'>
            <path
              id='Path_2445'
              data-name='Path 2445'
              d='M144.4,376h-7.467a.933.933,0,0,0-.933.933h0V387.2a.933.933,0,0,0,.933.933H144.4a.933.933,0,0,0,.933-.933h0V376.933A.933.933,0,0,0,144.4,376Zm-.934,10.267h-5.6v-8.4h5.6Z'
              transform='translate(-136.002 -376)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2853'
          data-name='Group 2853'
          transform='translate(29.868 40.133)'
        >
          <g id='Group_2852' data-name='Group 2852'>
            <path
              id='Path_2446'
              data-name='Path 2446'
              d='M264.4,344h-7.467a.933.933,0,0,0-.933.933h0v14a.933.933,0,0,0,.933.933H264.4a.933.933,0,0,0,.933-.933h0v-14A.933.933,0,0,0,264.4,344Zm-.934,14h-5.6V345.867h5.6Z'
              transform='translate(-256.002 -344)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2855'
          data-name='Group 2855'
          transform='translate(43.868 31.733)'
        >
          <g id='Group_2854' data-name='Group 2854'>
            <path
              id='Path_2447'
              data-name='Path 2447'
              d='M384.4,272h-7.467a.933.933,0,0,0-.933.933h0v22.4a.933.933,0,0,0,.933.933H384.4a.933.933,0,0,0,.933-.933h0v-22.4A.933.933,0,0,0,384.4,272Zm-.934,22.4h-5.6V273.867h5.6Z'
              transform='translate(-376.002 -272)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2857'
          data-name='Group 2857'
          transform='translate(1.356 18.702)'
        >
          <g id='Group_2856' data-name='Group 2856'>
            <path
              id='Path_2448'
              data-name='Path 2448'
              d='M42.263,162.177l-.017-.005-6.533-1.867-.513,1.8,4.574,1.307L11.611,181.889l1.024,1.56,27.7-18.179L38.8,170.262l1.784.549,2.3-7.467A.934.934,0,0,0,42.263,162.177Z'
              transform='translate(-11.611 -160.305)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2859'
          data-name='Group 2859'
          transform='translate(36.401 3.733)'
        >
          <g id='Group_2858' data-name='Group 2858'>
            <path
              id='Path_2449'
              data-name='Path 2449'
              d='M326.654,37.255a.933.933,0,0,0-.511-.255l-4.022-.615-1.807-3.85a.933.933,0,0,0-1.69,0l-1.807,3.85L312.794,37a.933.933,0,0,0-.527,1.574l2.938,3.011-.695,4.263a.933.933,0,0,0,1.373.967l3.586-1.982,3.586,1.982a.933.933,0,0,0,1.373-.967l-.695-4.263,2.938-3.011A.933.933,0,0,0,326.654,37.255Zm-4.587,3.364a.932.932,0,0,0-.253.8l.462,2.831-2.356-1.3a.933.933,0,0,0-.9,0l-2.356,1.3.462-2.831a.932.932,0,0,0-.253-.8l-2-2.048,2.719-.416a.931.931,0,0,0,.7-.526l1.174-2.5,1.174,2.5a.932.932,0,0,0,.7.526l2.719.416Z'
              transform='translate(-312.002 -31.998)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2861'
          data-name='Group 2861'
          transform='translate(41.774 22.245)'
        >
          <g id='Group_2860' data-name='Group 2860'>
            <path
              id='Path_2450'
              data-name='Path 2450'
              d='M361.942,190.672a10.25,10.25,0,0,1-1.778.155h-.014a10.286,10.286,0,0,1-1.773-.153l-.321,1.839a18.6,18.6,0,0,0,2.109.18,12.1,12.1,0,0,0,2.1-.184Z'
              transform='translate(-358.057 -190.672)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2863'
          data-name='Group 2863'
          transform='translate(45.621 0.176)'
        >
          <g id='Group_2862' data-name='Group 2862'>
            <path
              id='Path_2451'
              data-name='Path 2451'
              d='M391.342,1.508l-.316,1.839a10.177,10.177,0,0,1,3.351,1.208l.929-1.619A12.016,12.016,0,0,0,391.342,1.508Z'
              transform='translate(-391.026 -1.508)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2865'
          data-name='Group 2865'
          transform='translate(37.772 0.187)'
        >
          <g id='Group_2864' data-name='Group 2864'>
            <path
              id='Path_2452'
              data-name='Path 2452'
              d='M327.708,1.6a12.054,12.054,0,0,0-3.955,1.453l.94,1.613a10.191,10.191,0,0,1,3.344-1.229Z'
              transform='translate(-323.753 -1.602)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2867'
          data-name='Group 2867'
          transform='translate(49.006 18.729)'
        >
          <g id='Group_2866' data-name='Group 2866'>
            <path
              id='Path_2453'
              data-name='Path 2453'
              d='M422.772,160.531a10.3,10.3,0,0,1-2.73,2.294l.936,1.615a12.15,12.15,0,0,0,3.223-2.708Z'
              transform='translate(-420.042 -160.531)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2869'
          data-name='Group 2869'
          transform='translate(53.519 12.099)'
        >
          <g id='Group_2868' data-name='Group 2868'>
            <path
              id='Path_2454'
              data-name='Path 2454'
              d='M460.795,103.7l-1.454.035a10.241,10.241,0,0,1-.616,3.512l1.755.638a12.138,12.138,0,0,0,.727-4.177Z'
              transform='translate(-458.725 -103.703)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2871'
          data-name='Group 2871'
          transform='translate(51.711 4.302)'
        >
          <g id='Group_2870' data-name='Group 2870'>
            <path
              id='Path_2455'
              data-name='Path 2455'
              d='M444.65,36.875l-1.425,1.2a10.223,10.223,0,0,1,1.794,3.078l1.752-.645A12.071,12.071,0,0,0,444.65,36.875Z'
              transform='translate(-443.225 -36.875)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2873'
          data-name='Group 2873'
          transform='translate(32.455 4.355)'
        >
          <g id='Group_2872' data-name='Group 2872'>
            <path
              id='Path_2456'
              data-name='Path 2456'
              d='M280.274,37.328a12.093,12.093,0,0,0-2.1,3.652l1.755.634a10.223,10.223,0,0,1,1.777-3.089Z'
              transform='translate(-278.174 -37.328)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2875'
          data-name='Group 2875'
          transform='translate(34.585 18.743)'
        >
          <g id='Group_2874' data-name='Group 2874'>
            <path
              id='Path_2457'
              data-name='Path 2457'
              d='M297.859,160.656l-1.427,1.2a12.154,12.154,0,0,0,3.228,2.7l.933-1.617A10.286,10.286,0,0,1,297.859,160.656Z'
              transform='translate(-296.432 -160.656)'
              fill={color}
            />
          </g>
        </g>
        <g
          id='Group_2877'
          data-name='Group 2877'
          transform='translate(31.735 12.154)'
        >
          <g id='Group_2876' data-name='Group 2876'>
            <path
              id='Path_2458'
              data-name='Path 2458'
              d='M273.873,104.18l-1.867,0a12.084,12.084,0,0,0,.736,4.147l1.753-.642A10.227,10.227,0,0,1,273.873,104.18Z'
              transform='translate(-272.006 -104.18)'
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Members = ({
  color = 'currentColor',
  width = '56px',
  height = '56px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 56 56'
    >
      <path
        id='Path_2434'
        data-name='Path 2434'
        d='M56,21.656a4.49,4.49,0,0,0-3.218-4.326l-5.814-1.743V14.215a6.344,6.344,0,0,0,2.71-5.183V6.323a6.323,6.323,0,1,0-12.645,0v2.71a6.343,6.343,0,0,0,2.71,5.183v1.371l-4.065,1.219-4.065-1.219V14.215a6.344,6.344,0,0,0,2.71-5.183V6.323a6.323,6.323,0,1,0-12.645,0v2.71a6.343,6.343,0,0,0,2.71,5.183v1.371l-4.065,1.219-4.065-1.219V14.215a6.344,6.344,0,0,0,2.71-5.183V6.323a6.323,6.323,0,0,0-12.645,0v2.71a6.343,6.343,0,0,0,2.71,5.183v1.371L3.218,17.331A4.488,4.488,0,0,0,0,21.656v8.151H4.516V40.646H15.355v8.129H9.032V56H23.484V48.775H17.161V40.646h2.71V41.3l1.169.39a7.079,7.079,0,0,0,.665,1.6l-.552,1.1,2.2,2.2,1.1-.552a7.117,7.117,0,0,0,1.6.664l.39,1.169h3.109l.389-1.17a7.126,7.126,0,0,0,1.6-.664l1.1.552,2.2-2.2-.552-1.1a7.187,7.187,0,0,0,.665-1.6l1.17-.389v-.651h2.71v8.129H32.516V56H46.968V48.775H40.645V40.646H51.484V29.807H56ZM21.677,54.194H10.839V50.581H21.677Zm23.484,0H34.323V50.581H45.161ZM43.355,1.807A4.525,4.525,0,0,1,47.78,5.42H45.374a7.688,7.688,0,0,1-3.422-.808l-.583-.291-.46.46a2.192,2.192,0,0,1-1.541.639H38.93a4.525,4.525,0,0,1,4.425-3.613ZM38.839,9.033V7.226h.529a3.955,3.955,0,0,0,2.324-.747,9.5,9.5,0,0,0,3.682.747h2.5V9.033a4.534,4.534,0,0,1-2.259,3.908l-.451.261v2.574l-1.806,1.2-1.806-1.2V13.2L41.1,12.94a4.533,4.533,0,0,1-2.259-3.908ZM28,1.807A4.525,4.525,0,0,1,32.425,5.42H30.019A7.688,7.688,0,0,1,26.6,4.611l-.583-.291-.46.46a2.192,2.192,0,0,1-1.541.639h-.438A4.525,4.525,0,0,1,28,1.807ZM23.484,9.033V7.226h.529a3.955,3.955,0,0,0,2.324-.747,9.5,9.5,0,0,0,3.682.747h2.5V9.033a4.534,4.534,0,0,1-2.259,3.908l-.451.261v2.574L28,16.979l-1.806-1.2V13.2l-.451-.261a4.533,4.533,0,0,1-2.259-3.908Zm1.659,8.213L28,19.151l2.857-1.905,6.05,1.815a2.693,2.693,0,0,1,1.931,2.6V28H17.161V21.656a2.693,2.693,0,0,1,1.931-2.6ZM12.645,1.807A4.525,4.525,0,0,1,17.07,5.42h-.438a2.2,2.2,0,0,1-1.542-.639l-.461-.46-.583.291a7.679,7.679,0,0,1-3.421.808H8.22a4.525,4.525,0,0,1,4.425-3.613ZM8.129,9.033V7.226h2.5a9.5,9.5,0,0,0,3.682-.747,3.957,3.957,0,0,0,2.324.747h.529V9.033A4.533,4.533,0,0,1,14.9,12.94l-.451.261v2.574l-1.806,1.2-1.806-1.2V13.2l-.451-.261A4.533,4.533,0,0,1,8.129,9.033ZM1.806,21.656a2.693,2.693,0,0,1,1.931-2.6l6.05-1.816,2.857,1.906L15.5,17.246l1.975.593a4.474,4.474,0,0,0-2.123,3.818V28H1.806ZM34.323,39.994l-.907.3-.1.514a5.365,5.365,0,0,1-.8,1.932l-.291.436.428.856-.357.358-.855-.429L31,44.253a5.359,5.359,0,0,1-1.932.8l-.514.1-.3.909h-.5l-.3-.908-.514-.1a5.349,5.349,0,0,1-1.932-.8l-.437-.291-.855.429-.357-.358.428-.856-.291-.436a5.343,5.343,0,0,1-.8-1.932l-.1-.514-.907-.3v-.5l.907-.3.1-.514a5.352,5.352,0,0,1,.8-1.932l.291-.436-.428-.857.357-.357.855.429L25,35.231a5.359,5.359,0,0,1,1.932-.8l.514-.1.3-.908h.5l.3.908.514.1a5.349,5.349,0,0,1,1.932.8l.437.291.855-.429.357.357-.428.857.291.436a5.33,5.33,0,0,1,.8,1.932l.1.514.907.3Zm15.355-1.155H36.129v-.651L34.96,37.8a7.063,7.063,0,0,0-.665-1.6l.552-1.1-2.2-2.2-1.1.552a7.117,7.117,0,0,0-1.6-.664l-.39-1.169H26.445l-.389,1.17a7.125,7.125,0,0,0-1.6.664l-1.1-.552-2.2,2.2.552,1.1a7.169,7.169,0,0,0-.665,1.6l-1.17.389v.651H6.323V29.807H49.677ZM54.194,28H40.645V21.656a4.474,4.474,0,0,0-2.123-3.818l1.975-.593,2.857,1.905,2.857-1.905,6.05,1.815a2.693,2.693,0,0,1,1.931,2.6Zm0,0'
        transform='translate(0 0)'
        fill={color}
      />
    </svg>
  )
}

export const MenuIcon = ({
  color = 'currentColor',
  width = '26px',
  height = '18px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 25.5 18'
    >
      <g id='iconfinder_menu_4092560' transform='translate(-2 -6)'>
        <path
          id='Path_216'
          data-name='Path 216'
          d='M26.589,6H2.911A.842.842,0,0,0,2,6.75a.842.842,0,0,0,.911.75H26.589a.842.842,0,0,0,.911-.75A.842.842,0,0,0,26.589,6Z'
          fill={color}
        />
        <path
          id='Path_217'
          data-name='Path 217'
          d='M2.75,16.5H12.5a.75.75,0,0,0,0-1.5H2.75a.75.75,0,0,0,0,1.5Z'
          transform='translate(0 -0.75)'
          fill={color}
        />
        <path
          id='Path_218'
          data-name='Path 218'
          d='M23.562,24H2.938a.769.769,0,1,0,0,1.5H23.562a.769.769,0,1,0,0-1.5Z'
          transform='translate(0 -1.5)'
          fill={color}
        />
      </g>
    </svg>
  )
}

export const ArrowLeftRound = ({
  color = 'currentColor',
  width = '18px',
  height = '14px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 14.4'
    >
      <path
        id='_ionicons_svg_ios-arrow-round-back_2_'
        data-name='_ionicons_svg_ios-arrow-round-back (2)'
        d='M119.925,160.3a.98.98,0,0,1,.007,1.38l-4.554,4.567h13.754a.975.975,0,0,1,0,1.95H115.379l4.562,4.567a.987.987,0,0,1-.008,1.38.972.972,0,0,1-1.373-.008l-6.182-6.225a1.1,1.1,0,0,1-.2-.307.93.93,0,0,1-.075-.375.977.977,0,0,1,.278-.682l6.182-6.225A.956.956,0,0,1,119.925,160.3Z'
        transform='translate(-112.1 -160.024)'
        fill={color}
      />
    </svg>
  )
}

export const CoinIcon = ({ width = '48px', height = '48px' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 48 48'
    >
      <g
        id='Group_2993'
        data-name='Group 2993'
        transform='translate(-608 -807)'
      >
        <path
          id='Path_3646'
          data-name='Path 3646'
          d='M20,0h8A20,20,0,0,1,48,20v8A20,20,0,0,1,28,48H20A20,20,0,0,1,0,28V20A20,20,0,0,1,20,0Z'
          transform='translate(608 807)'
          fill='#ffe8b2'
        />
        <g id='coin' transform='translate(620 819)'>
          <g id='Group_2982' data-name='Group 2982' transform='translate(0)'>
            <g id='Group_2981' data-name='Group 2981'>
              <path
                id='Path_3639'
                data-name='Path 3639'
                d='M20.485,3.515A12,12,0,0,0,3.515,20.485,12,12,0,0,0,20.485,3.515ZM12,22.594A10.594,10.594,0,1,1,22.594,12,10.606,10.606,0,0,1,12,22.594Z'
                transform='translate(0 0)'
                fill='#ffb300'
              />
            </g>
          </g>
          <g
            id='Group_2984'
            data-name='Group 2984'
            transform='translate(8.284 4.519)'
          >
            <g id='Group_2983' data-name='Group 2983'>
              <path
                id='Path_3640'
                data-name='Path 3640'
                d='M181.2,103.179H179.7a1.556,1.556,0,1,1,0-3.112h3.013a.7.7,0,1,0,0-1.406h-1.556V97.1a.7.7,0,0,0-1.406,0V98.66h-.05a2.962,2.962,0,1,0,0,5.925H181.2a1.556,1.556,0,0,1,0,3.113H178.19a.7.7,0,0,0,0,1.406h1.556v1.556a.7.7,0,0,0,1.406,0V109.1h.05a2.963,2.963,0,0,0,0-5.925Z'
                transform='translate(-176.734 -96.401)'
                fill='#ffb300'
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const CartIconBig = ({ width = '48px', height = '48px' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 48 48'
    >
      <g
        id='Group_2994'
        data-name='Group 2994'
        transform='translate(-601 -757)'
      >
        <rect
          id='Rectangle_541'
          data-name='Rectangle 541'
          width='48'
          height='48'
          rx='20'
          transform='translate(601 757)'
          fill='#facaca'
        />
        <g id='buy-online' transform='translate(610.988 768.246)'>
          <g
            id='Group_2985'
            data-name='Group 2985'
            transform='translate(3.013 0.754)'
          >
            <path
              id='Path_3641'
              data-name='Path 3641'
              d='M6.071,15.424H23.177a.726.726,0,0,0,.724-.674l.778-10.885a.726.726,0,0,0-.724-.778h-8.6V1.48a.726.726,0,1,0-1.452,0V3.087H5.832c-.051-.618-2.058-.416-.7-.077-.113-.517-.571-.277-.71,0L5.29,14.073a3.058,3.058,0,0,0,.78,6.016h.121a3.058,3.058,0,1,0,5.2,0h6.849a3.059,3.059,0,1,0,5.175-.042.726.726,0,0,0-.241-1.41H6.071a1.607,1.607,0,0,1,0-3.213ZM13.9,4.539V9.058L12.8,7.964a.726.726,0,0,0-1.027,1.027l2.333,2.333a.726.726,0,0,0,1.027,0L17.47,8.991a.726.726,0,0,0-1.027-1.027L15.35,9.058V4.539h7.825L22.5,13.972H6.739L5.953,4.539Zm6.946,15.55A1.607,1.607,0,1,1,19.237,21.7,1.608,1.608,0,0,1,20.844,20.089Zm-12.051,0A1.607,1.607,0,1,1,7.186,21.7,1.608,1.608,0,0,1,8.792,20.089Z'
              transform='translate(-3.013 -0.754)'
              fill='#ff6e6e'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export const UserIcon = ({ width = '48px', height = '48px' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 48 48'
    >
      <g
        id='Group_2995'
        data-name='Group 2995'
        transform='translate(-612 -752)'
      >
        <path
          id='Path_3647'
          data-name='Path 3647'
          d='M20,0h8A20,20,0,0,1,48,20v8A20,20,0,0,1,28,48H20A20,20,0,0,1,0,28V20A20,20,0,0,1,20,0Z'
          transform='translate(612 752)'
          fill='#d1f9f5'
        />
        <path
          id='Path_3642'
          data-name='Path 3642'
          d='M-707.226-726.091a.506.506,0,0,1-.23.677.506.506,0,0,1-.677-.23,11.921,11.921,0,0,1-.919-2.574,12.016,12.016,0,0,1-.311-2.719,11.963,11.963,0,0,1,3.515-8.485,11.962,11.962,0,0,1,8.485-3.515,11.962,11.962,0,0,1,8.485,3.515,11.963,11.963,0,0,1,3.515,8.485,12.016,12.016,0,0,1-.311,2.719,11.929,11.929,0,0,1-.919,2.574.506.506,0,0,1-.677.23.506.506,0,0,1-.23-.677,10.888,10.888,0,0,0,.84-2.352,11.01,11.01,0,0,0,.283-2.493A10.952,10.952,0,0,0-689.6-738.7a10.952,10.952,0,0,0-7.768-3.218,10.952,10.952,0,0,0-7.768,3.218,10.952,10.952,0,0,0-3.218,7.768,11.017,11.017,0,0,0,.283,2.493,10.9,10.9,0,0,0,.84,2.352Zm19.154,2.746a12.05,12.05,0,0,1-4.152,3.254,11.947,11.947,0,0,1-5.139,1.155,11.947,11.947,0,0,1-5.139-1.155,12.051,12.051,0,0,1-4.16-3.264.5.5,0,0,1-.109-.386h0a3.522,3.522,0,0,1,1.1-2.245,6.632,6.632,0,0,1,2.253-1.223c.4-.146.832-.281,1.256-.412a11.4,11.4,0,0,0,1.621-.582l.064-.035a.85.85,0,0,0,.408-.456.62.62,0,0,0-.045-.475l-.01-.021-.009-.016-.014-.026c-.067-.114-.163-.254-.267-.406a6.317,6.317,0,0,1-.928-1.8,1.354,1.354,0,0,1-.656-.588,3.944,3.944,0,0,1-.424-1.009,3.77,3.77,0,0,1-.116-.57c0-.005,0-.01,0-.016a1.387,1.387,0,0,1,0-.268.947.947,0,0,1,.3-.627.989.989,0,0,1,.43-.23l-.015-.432a4.265,4.265,0,0,1,2.5-4.277,4.8,4.8,0,0,1,1.967-.414,4.8,4.8,0,0,1,1.967.415,4.264,4.264,0,0,1,2.5,4.277v0h0l-.015.43a.987.987,0,0,1,.431.231.947.947,0,0,1,.295.625,1.409,1.409,0,0,1,0,.285l0,.016a3.824,3.824,0,0,1-.114.558,3.921,3.921,0,0,1-.423,1.007,1.353,1.353,0,0,1-.656.587,6.321,6.321,0,0,1-.929,1.8c-.11.162-.212.312-.279.428l-.018.035a.626.626,0,0,0-.045.479.85.85,0,0,0,.409.457l.064.033a11.415,11.415,0,0,0,1.625.584c.423.131.857.265,1.252.41a6.631,6.631,0,0,1,2.253,1.223,3.521,3.521,0,0,1,1.1,2.245.5.5,0,0,1-.117.4Zm-4.583,2.339a11.025,11.025,0,0,0,3.664-2.814,2.462,2.462,0,0,0-.747-1.422,5.756,5.756,0,0,0-1.916-1.017c-.4-.146-.8-.271-1.2-.394a12.03,12.03,0,0,1-1.783-.647c-.028-.014-.065-.035-.111-.061a1.843,1.843,0,0,1-.868-1.023,1.62,1.62,0,0,1,.1-1.243c.009-.018.024-.045.046-.082.1-.176.206-.33.319-.495a5.142,5.142,0,0,0,.874-1.816h0l.005-.022a.505.505,0,0,1,.6-.357c.012-.008.026-.076.082-.164a2.907,2.907,0,0,0,.3-.737,2.755,2.755,0,0,0,.083-.4v-.013a.49.49,0,0,0,0-.062h-.021a.853.853,0,0,0-.164,0,.5.5,0,0,1-.075,0,.505.505,0,0,1-.487-.523l.032-.917h0a3.3,3.3,0,0,0-1.905-3.321,3.788,3.788,0,0,0-1.551-.327,3.79,3.79,0,0,0-1.551.327,3.3,3.3,0,0,0-1.907,3.323l.031.91a.532.532,0,0,1,0,.071.505.505,0,0,1-.55.456.864.864,0,0,0-.173,0h-.022a.5.5,0,0,0,0,.053v.009a2.721,2.721,0,0,0,.084.408,2.922,2.922,0,0,0,.3.74c.056.088.068.157.08.164h0a.506.506,0,0,1,.606.38,5.138,5.138,0,0,0,.873,1.813c.107.158.207.3.3.469l.017.027.03.053.017.031a1.619,1.619,0,0,1,.1,1.243,1.842,1.842,0,0,1-.863,1.022c-.036.021-.075.042-.116.062a11.985,11.985,0,0,1-1.779.646c-.4.123-.808.25-1.2.4a5.758,5.758,0,0,0-1.917,1.017,2.462,2.462,0,0,0-.747,1.422,11.027,11.027,0,0,0,3.664,2.814,10.94,10.94,0,0,0,4.708,1.056,10.94,10.94,0,0,0,4.708-1.056Z'
          transform='translate(1333.363 1506.936)'
          fill='#27c7b7'
        />
      </g>
    </svg>
  )
}

export const DeliveryIcon = ({ width = '48px', height = '48px' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 48 48'
    >
      <g
        id='Group_2996'
        data-name='Group 2996'
        transform='translate(-1787 -804)'
      >
        <rect
          id='Rectangle_541'
          data-name='Rectangle 541'
          width='48'
          height='48'
          rx='20'
          transform='translate(1787 804)'
          fill='#f8dac2'
        />
        <path
          id='delivery-truck_1_'
          data-name='delivery-truck (1)'
          d='M19.621,630.473a2.216,2.216,0,0,0-1.564.645,2.171,2.171,0,0,0,0,3.108,2.225,2.225,0,0,0,1.564.645,2.2,2.2,0,0,0,0-4.4Zm0,3.421a1.222,1.222,0,1,1,0-2.443,1.222,1.222,0,0,1,0,2.443Zm.567-10.747a.475.475,0,0,0-.327-.127H17.354a.49.49,0,0,0-.489.489v4.007a.49.49,0,0,0,.489.489h3.978a.49.49,0,0,0,.489-.489v-2.683a.489.489,0,0,0-.161-.362Zm.655,3.88h-3v-3.035H19.67l1.173,1.056ZM7.687,630.473a2.216,2.216,0,0,0-1.564.645,2.171,2.171,0,0,0,0,3.108,2.225,2.225,0,0,0,1.564.645,2.2,2.2,0,0,0,0-4.4Zm0,3.421a1.222,1.222,0,1,1,0-2.443,1.222,1.222,0,0,1,0,2.443Zm-3.26-2.82H3.445v-1.3a.489.489,0,0,0-.977,0v1.789a.49.49,0,0,0,.489.489H4.428a.489.489,0,0,0,0-.977Zm2.478-2.663a.49.49,0,0,0-.489-.489H.489a.489.489,0,0,0,0,.977H6.417A.487.487,0,0,0,6.905,628.411Zm-5.425-1.764,5.928.034A.493.493,0,0,0,7.9,626.2a.484.484,0,0,0-.484-.494l-5.928-.034h0a.489.489,0,0,0,0,.977Zm1-2.219H8.406a.489.489,0,1,0,0-.977H2.478a.489.489,0,1,0,0,.977Zm21.341-.66h0l-3.5-2.9a.481.481,0,0,0-.313-.112H15.892V619a.49.49,0,0,0-.489-.489H2.957a.49.49,0,0,0-.489.489v3.577a.489.489,0,0,0,.977,0v-3.089H14.92v11.587H10.913a.489.489,0,0,0,0,.977H16.88a.489.489,0,0,0,0-.977H15.9v-9.339h3.939l3.186,2.639-.034,6.69H22.48a.489.489,0,0,0,0,.977h.992a.486.486,0,0,0,.489-.484L24,624.15A.516.516,0,0,0,23.819,623.768Z'
          transform='translate(1799 201.49)'
          fill='#ff811d'
        />
      </g>
    </svg>
  )
}

export const IosArrowUp = ({
  color = 'currentColor',
  width = '7px',
  height = '10px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 7 10'
    >
      <path
        id='_ionicons_svg_ios-arrow-round-up'
        d='M166.5,115.723a.454.454,0,0,1-.639,0l-2.115-2.108v8.034a.452.452,0,0,1-.9,0v-8.034l-2.115,2.112a.457.457,0,0,1-.639,0,.45.45,0,0,1,0-.636l2.883-2.862a.507.507,0,0,1,.142-.094.431.431,0,0,1,.174-.035.453.453,0,0,1,.316.129l2.883,2.862A.442.442,0,0,1,166.5,115.723Z'
        transform='translate(-159.962 -112.1)'
        fill={color}
      />
    </svg>
  )
}

export const IosArrowDown = ({
  color = 'currentColor',
  width = '7px',
  height = '10px'
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 7 10'
    >
      <path
        id='_ionicons_svg_ios-arrow-round-up'
        d='M166.5,118.477a.454.454,0,0,0-.639,0l-2.115,2.108v-8.034a.452.452,0,0,0-.9,0v8.034l-2.115-2.112a.457.457,0,0,0-.639,0,.45.45,0,0,0,0,.636l2.883,2.862a.507.507,0,0,0,.142.094.431.431,0,0,0,.174.035.453.453,0,0,0,.316-.129l2.883-2.862A.442.442,0,0,0,166.5,118.477Z'
        transform='translate(-159.962 -112.1)'
        fill={color}
      />
    </svg>
  )
}
